import firebaseConfig from "./config";
// import firebase from 'firebase/app'
import { initializeApp } from "firebase/app"

import { navigate } from "gatsby"
import {
  getAuth,
  // signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  signOut,
  getAdditionalUserInfo,
  GoogleAuthProvider,
  // signInWithRedirect,
  updateEmail,
  sendPasswordResetEmail,
  signInWithPopup,
  // getMultiFactorResolver,
  // PhoneAuthProvider,
  // RecaptchaVerifier,
  // updateCurrentUser
} from "firebase/auth"
import {
  arrayUnion,
  arrayRemove,
  updateDoc,
  setDoc,
  getDoc,
  getDocs,
  doc,
  getFirestore,
  onSnapshot,
  collection,
  getCountFromServer,
  query,
  where,
  orderBy,
  limit,
  deleteDoc,
  startAfter,
  deleteField,
  // writeBatch
} from "firebase/firestore"
import { getFunctions, httpsCallable } from "firebase/functions"
import { getStorage, uploadBytes, ref, getDownloadURL, deleteObject } from "firebase/storage"
import { getVertexAI, getGenerativeModel } from "firebase/vertexai";

// import { getMessaging } from 'firebase/messaging';
// import { getMessaging, getToken } from "firebase/messaging";
// import { getDatabase, ref, set } from "firebase/database"
// import { connectFunctionsEmulator } from "firebase/functions";


 // Sign in with popup && Google as the provider
const googleProvider = new GoogleAuthProvider();

const app = initializeApp(firebaseConfig)
// const messaging = getMessaging(app);
// Initialize the Vertex AI service
const vertexAI = getVertexAI(app);
// Initialize the generative model with a model that supports your use case
// Gemini 1.5 Pro is versatile and can accept both text-only or multimodal prompt inputs
// const model = getGenerativeModel(vertexAI, { model: "gemini-1.0-pro-001" });
const model = getGenerativeModel(vertexAI, { model: "gemini-2.5-flash-lite" });

  // Hilfsfunktion für das heutige Datum (Timestamp)
  const getTodayTimestamp = () => {
    return new Date().setHours(0, 0, 0, 0); // Start des aktuellen Tages
  };

class Firebase {
  constructor() {
    if(!firebaseInstance) {
      // app.initializeApp(firebaseConfig);

      this.auth = getAuth(app)
      this.db = getFirestore(app)
      this.functions = getFunctions(app, 'europe-west3')
      // this.functions = getFunctions(app)
      this.storage = getStorage(app)
      this.paginationCursors = {}

      // CORS
      // connectFunctionsEmulator(this.functions, "localhost", 5001);

      // Listen to the auth state, log enrolled factors for debugging
      // this.auth.onAuthStateChanged(user => {
      //   if (user) {
      //   console.log(user.multiFactor.enrolledFactors)
      //   } else {
      //     console.log('signed out')
      //   }
      // })

      // console.log(this.auth.uid)



      // CHECK CLAIMS
      //   this.auth.onAuthStateChanged(async (user) => {
      //     if (user) {
      //         try {
      //             const idTokenResult = await user.getIdTokenResult();
      //             const claims = idTokenResult.claims;
      
      //             console.log(claims)
      //             console.log(claims.organizationId);
      //             // Prüfe auf ein Custom Claim, z. B. admin
      //             if (claims.admin) {
      //                 console.log('Benutzer ist ein Admin.');
      //             } else {
      //                 console.log('Benutzer ist kein Admin.');
      //             }
      //         } catch (error) {
      //             console.error('Fehler beim Abrufen der Custom Claims:', error);
      //         }
      //     } else {
      //         console.log('User ist abgemeldet');
      //     }
      // });

    }
  }


  // Wrap in an async function so you can use await
// async getPrompt(prompt) {
//   // Provide a prompt that contains text
//   // const prompt = "Write a story about a magic backpack."

//   // To stream generated text output, call generateContentStream with the text input
//   const result = await model.generateContentStream(prompt);

//   for await (const chunk of result.stream) {
//     const chunkText = chunk.text();
//     console.log(chunkText);
//   }

//   console.log('aggregated response: ', await result.response);
// }


sendVerificationEmail = (email, lang) => {
  const callable = httpsCallable(this.functions, "sendCustomVerificationEmail");
  return callable({ email, lang });
};

// sendCustomPasswordResetEmail({ email, lang }) {
//     const callable = httpsCallable(this.functions, 'sendPasswordResetEmail');
//     return callable({ email, lang });
//   }


async getPrompt(prompt) {
  try {
    const result = await model.generateContentStream(prompt);

    let aggregatedResponse = '';
    for await (const chunk of result.stream) {
      const chunkText = chunk.text();
      console.log(chunkText);
      aggregatedResponse += chunkText;
    }

    console.log('aggregated response: ', aggregatedResponse);
    return aggregatedResponse;
  } catch (error) {
    console.error('Error generating text:', error);
    throw error;
  }
}

// async businessCopilot({
//  question,
//  context,
//  language
// }) {


// const callable =
//   httpsCallable(
//   this.functions,
//   "businessCopilot"
//   );


//   const result =
//   await callable({

//   question,

//   context,

//   language

//   });


//   return result.data;


//   }


async businessCopilot({
  question,
  context,
  language,
  mode = 'analysis',
}) {
  const callable = httpsCallable(
    this.functions,
    'businessCopilot'
  )

  const result = await callable({
    question,
    context,
    language,
    mode,
  })

  return result.data
}


  async goToBillingPortal() {
    try {
      const functionRef = httpsCallable(this.functions, 'ext-firestore-stripe-subscriptions-createPortalLink');
      
      const { data } = await functionRef({ returnUrl: `${window.location.origin}/app/user` });
      window.location.assign(data.url);
    } catch (error) {
      console.error('Error calling billing portal:', error);
      throw error; // Fehler weiterwerfen, damit er in der aufrufenden Komponente abgefangen werden kann
    }
  }


  async saveOfferBlob ({blob, filename}) {
  
    const metadata = {
      contentType: 'application/pdf',
    };

    const storageRef = ref(this.storage, `${filename}.pdf`);

    await uploadBytes(storageRef, blob, metadata).then((snapshot) => {
      console.log('PDF Uploaded');
    });
}

loadOfferPdf({ filename }) {
  // Create a reference to the file we want to download
  var pdfRef = ref(this.storage, `${filename}.pdf`)
  // console.log(pdfRef)
  // Get the download URL
  const pdfUrl = getDownloadURL(pdfRef).then((url) => {
    console.log('PDF available at', url);
  return url

  }).catch(function(error) {

    // A full list of error codes is available at
    // https://firebase.google.com/docs/storage/web/handle-errors
    switch (error.code) {
      case 'storage/object-not-found':
        // File doesn't exist
        break;

      case 'storage/unauthorized':
        // User doesn't have permission to access the object
        break;

      case 'storage/canceled':
        // User canceled the upload
        break;


      case 'storage/unknown':
        // Unknown error occurred, inspect the server response
        break;

      default:
        break;

    }
  });
return pdfUrl
}


  async saveInvoiceBlob ({blob, filename}) {

    const metadata = {
      contentType: 'application/pdf',
    };

    const storageRef = ref(this.storage, `${filename}.pdf`);

    await uploadBytes(storageRef, blob, metadata).then((snapshot) => {
      console.log('PDF Uploaded!');
    });
  }


  loadInvoicePdf({ filename }) {
  // Create a reference to the file we want to download
  var pdfRef = ref(this.storage, `${filename}.pdf`)
  // console.log(pdfRef)
  // Get the download URL
  const pdfUrl = getDownloadURL(pdfRef).then((url) => {
    console.log('PDF available at', url);
  return url

  }).catch(function(error) {

  // A full list of error codes is available at
  // https://firebase.google.com/docs/storage/web/handle-errors
  switch (error.code) {
    case 'storage/object-not-found':
      // File doesn't exist
      break;

    case 'storage/unauthorized':
      // User doesn't have permission to access the object
      break;

    case 'storage/canceled':
      // User canceled the upload
      break;


    case 'storage/unknown':
      // Unknown error occurred, inspect the server response
      break;

    default:
      break;
  }
  });
  return pdfUrl
  }

  async saveOrderBlob ({blob, filename}) {

    const metadata = {
      contentType: 'application/pdf',
    };

    const storageRef = ref(this.storage, `${filename}.pdf`);

    await uploadBytes(storageRef, blob, metadata).then((snapshot) => {
      console.log('PDF Uploaded!');
    });
  }

  loadOrderPdf({ filename }) {
    // Create a reference to the file we want to download
    var pdfRef = ref(this.storage, `${filename}.pdf`)
    // console.log(pdfRef)
    // Get the download URL
    const pdfUrl = getDownloadURL(pdfRef).then((url) => {
      console.log('PDF available at', url);
    return url
  
    }).catch(function(error) {
  
    // A full list of error codes is available at
    // https://firebase.google.com/docs/storage/web/handle-errors
    switch (error.code) {
      case 'storage/object-not-found':
        // File doesn't exist
        break;
  
      case 'storage/unauthorized':
        // User doesn't have permission to access the object
        break;
  
      case 'storage/canceled':
        // User canceled the upload
        break;
  
  
      case 'storage/unknown':
        // Unknown error occurred, inspect the server response
        break;
  
      default:
        break;
    }
    });
    return pdfUrl
    }

  deleteFromStorage ({ filename }) {
    var deleteRef = ref(this.storage, `${filename}.pdf`)
    // Delete the file
    deleteObject(deleteRef).then(() => {
      console.log('File deleted successfully')
    }).catch((error) => {
      console.log('Uh-oh, an error occurred!')
    });
  }

  // getUserProfile ({ userId, onSnapshot }) {
  //   return this.db.collection('publicProfiles')
  //     .where('userId', '==', userId)
  //     .limit(1)
  //     .onSnapshot(onSnapshot)
  // }

  // async checkOfferSize({ userId }) {
  //   // return this.db.collection('offers').get().then(snap => {
  //   //  const size = snap.size // will return the collection size
  //   //  return size.length
  //   const today = new Date()
  //   const year = today.getFullYear()
  //   const month = today.getMonth()
  //   // });
  //   return this.db.collection('offers')
  //     .where('user', '==', userId)
  //     .where('year', '==', year.toString())
  //     .where('month', '==', (month + 1).toString())
  //     .get().then(function (snap){
  //       const abc = snap.size
  //       return abc // will return the collection size
  //
  //   });
  // }


  /**********************************
  USER ACTIONS
  **********************************/

  getUser ({ userId, handler }) {
    onSnapshot(
      query(
        collection(this.db, "users"),
        where('userId', '==', userId),
        limit(1)
      ),
        docs => handler(docs)
    )
  }

  async updateUserNewsletter({userId, newsletter}){
    const data = {
        newsletter,
    };

    const userRef = doc(this.db, 'users', userId)

    await setDoc(
      userRef, data, 
      { merge: true }
    ).then(() => {
      console.log("Updated Newsletter");
    })
    .catch((error) => {
      console.error(error);
    });
  }


  async deleteOrganizationData({ organizationId }) {
    try {
      const deleteOrgData = httpsCallable(this.functions, 'deleteOrganizationData');
      const response = await deleteOrgData({ organizationId });
  
      if (response.data.success) {
        console.log(response.data.message);
        return response.data;
      } else {
        throw new Error(response.data.message || 'Failed to delete organization data');
      }
    } catch (error) {
      console.error("Error in deleteOrganizationData:", error);
      throw error; // Fehler weitergeben
    }
  }


  // async deleteAllUserArticles({ organizationId }){
  //   const docRefs = query(collection(this.db, 'articles'), where('organizationId','==', organizationId))

  //   var batch = writeBatch(this.db)
  //   // Delete multiple Files
  //   onSnapshot(docRefs, (querySnapshot) => {
  //     querySnapshot.forEach(doc => {
  //       // console.log(doc)
  //       batch.delete(doc.ref)
  //     })
  //     // Commit the batch
  //     const commitBatch = async () => {
  //       batch.commit()
  //       .then(() => {
  //         console.log("Deleted all articles");
  //       })
  //       .catch((error) => {
  //         console.error(error)
  //       })
  //     }

  //     commitBatch()
      
  //   })
  // }
  
  // async deleteAllUserCustomers({ organizationId }){
  //   const docRefs = query(collection(this.db, 'customers'), where('organizationId','==', organizationId))

  //   var batch = writeBatch(this.db)
  //   // Delete multiple Files
  //   onSnapshot(docRefs, (querySnapshot) => {
  //     querySnapshot.forEach(doc => {
  //       // console.log(doc)
  //       batch.delete(doc.ref)
  //     })
  //     // Commit the batch
  //     const commitBatch = async () => {
  //       batch.commit()
  //       .then(() => {
  //         console.log("Deleted all customers");
  //       })
  //       .catch((error) => {
  //         console.error(error)
  //       })
  //     }

  //     commitBatch()
      
  //   })
  // }

  // async deleteAllUserExpenses({ organizationId }){
  //   const docRefs = query(collection(this.db, 'expenses'), where('organizationId','==', organizationId))

  //   var batch = writeBatch(this.db)
  //   // Delete multiple Files
  //   onSnapshot(docRefs, (querySnapshot) => {
  //     querySnapshot.forEach(doc => {
  //       // console.log(doc)
  //       batch.delete(doc.ref)
  //     })
  //     // Commit the batch
  //     const commitBatch = async () => {
  //       batch.commit()
  //       .then(() => {
  //         console.log("Deleted all expenses");
  //       })
  //       .catch((error) => {
  //         console.error(error)
  //       })
  //     }

  //     commitBatch()
      
  //   })
  // }

  // async deleteAllUserInvoices({ organizationId }){
  //   const docRefs = query(collection(this.db, 'invoices'), where('organizationId','==', organizationId))

  //   var batch = writeBatch(this.db)
  //   // Delete multiple Files
  //   onSnapshot(docRefs, (querySnapshot) => {
  //     querySnapshot.forEach(doc => {
  //       // console.log(doc)
  //       batch.delete(doc.ref)
  //     })
  //     // Commit the batch
  //     const commitBatch = async () => {
  //       batch.commit()
  //       .then(() => {
  //         console.log("Deleted all invoices");
  //       })
  //       .catch((error) => {
  //         console.error(error)
  //       })
  //     }

  //     commitBatch()
      
  //   })
  // }

  // async deleteAllUserNotes({ organizationId }){
  //   const docRefs = query(collection(this.db, 'notes'), where('organizationId','==', organizationId))

  //   var batch = writeBatch(this.db)
  //   // Delete multiple Files
  //   onSnapshot(docRefs, (querySnapshot) => {
  //     querySnapshot.forEach(doc => {
  //       // console.log(doc)
  //       batch.delete(doc.ref)
  //     })
  //     // Commit the batch
  //     const commitBatch = async () => {
  //       batch.commit()
  //       .then(() => {
  //         console.log("Deleted all notes");
  //       })
  //       .catch((error) => {
  //         console.error(error)
  //       })
  //     }

  //     commitBatch()
      
  //   })
  // }


  // async deleteAllUserOffers({ organizationId }){
  //   const docRefs = query(collection(this.db, 'offers'), where('organizationId','==', organizationId))

  //   var batch = writeBatch(this.db)
  //   // Delete multiple Files
  //   onSnapshot(docRefs, (querySnapshot) => {
  //     querySnapshot.forEach(doc => {
  //       // console.log(doc)
  //       batch.delete(doc.ref)
  //     })
  //     // Commit the batch
  //     const commitBatch = async () => {
  //       batch.commit()
  //       .then(() => {
  //         console.log("Deleted all offers");
  //       })
  //       .catch((error) => {
  //         console.error(error)
  //       })
  //     }

  //     commitBatch()
      
  //   })
  // }

  // async deleteUserSettings({ organizationId }){
  //   const docRefs = query(collection(this.db, 'settings'), where('organizationId','==', organizationId))

  //   var batch = writeBatch(this.db)
  //   // Delete multiple Files
  //   onSnapshot(docRefs, (querySnapshot) => {
  //     querySnapshot.forEach(doc => {
  //       // console.log(doc)
  //       batch.delete(doc.ref)
  //     })
  //     // Commit the batch
  //     const commitBatch = async () => {
  //       batch.commit()
  //       .then(() => {
  //         console.log("Deleted all settings");
  //       })
  //       .catch((error) => {
  //         console.error(error)
  //       })
  //     }

  //     commitBatch()
      
  //   })
  // }

  // async deleteAllUserTodos({ organizationId }){
  //   const docRefs = query(collection(this.db, 'todos'), where('organizationId','==', organizationId))

  //   var batch = writeBatch(this.db)
  //   // Delete multiple Files
  //   onSnapshot(docRefs, (querySnapshot) => {
  //     querySnapshot.forEach(doc => {
  //       // console.log(doc)
  //       batch.delete(doc.ref)
  //     })
  //     // Commit the batch
  //     const commitBatch = async () => {
  //       batch.commit()
  //       .then(() => {
  //         console.log("Deleted all todos");
  //       })
  //       .catch((error) => {
  //         console.error(error)
  //       })
  //     }

  //     commitBatch()
      
  //   })
  // }

  // async deleteAllUserCalendarentries({ organizationId }){
  //   const docRefs = query(collection(this.db, 'calendarentries'), where('organizationId','==', organizationId))

  //   var batch = writeBatch(this.db)
  //   // Delete multiple Files
  //   onSnapshot(docRefs, (querySnapshot) => {
  //     querySnapshot.forEach(doc => {
  //       // console.log(doc)
  //       batch.delete(doc.ref)
  //     })
  //     // Commit the batch
  //     const commitBatch = async () => {
  //       batch.commit()
  //       .then(() => {
  //         console.log("Deleted all calendarentries");
  //       })
  //       .catch((error) => {
  //         console.error(error)
  //       })
  //     }

  //     commitBatch()
  //   })
  // }

  


  // async updateUserActiveState({userId, active, canceledAt}){
  //   const data = {
  //       active,
  //       canceledAt
  //   };
  //   const userRef = doc(this.db, 'users', userId)
    
  //   await setDoc(
  //     userRef, data,
  //     { merge: true }
  //   ).then(() => {
  //     console.log("Updated user");
  //   })
  //   .catch((error) => {
  //     console.error(error);
  //   });
  // }

  
  // async updateUserTeamMembers({userId, teamMembers}){
  //   const data = {
  //       teamMembers,
  //   };
  //   const userRef = doc(this.db, 'users', userId)

  //   await setDoc(
  //     userRef, data,
  //     { merge: true }
  //   ).then(() => {
  //     console.log("Updated user");
  //   })
  //   .catch((error) => {
  //     console.error(error);
  //   });
  // }

  async updateUserEmail({userId, email}){
    const data = {
        email,
    };
    const userRef = doc(this.db, 'users', userId)

    await setDoc(
      userRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated user");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  // async deleteMember(member) {
  //   const memberRef = doc(this.db, 'users', member.id);
    
  //   await deleteDoc(memberRef)
  //     .then(() => {
  //       const uid = member.userId;
  //       const deleteMemberCallable = httpsCallable(this.functions, 'deleteMember');
  //       return deleteMemberCallable({ 
  //         uid 
  //       });
  //     })
  //     .catch(error => {
  //       console.error(error);
  //       throw error; // Optional: Fehler weiterwerfen für höhere Fehlerbehandlung
  //     });
  // }

  async deleteMember(member) {
    // const memberRef = doc(this.db, 'users', member.id);
    
    try {
      const deleteMemberCallable = httpsCallable(this.functions, 'deleteMember');
      await deleteMemberCallable({ uid: member.userId });
      // await deleteDoc(memberRef);
      console.log(`Mitglied ${member.userId} erfolgreich gelöscht`);

    } catch (error) {
      console.error('Fehler beim Löschen des Mitglieds:', error);
      throw error;
    }
  }


  async deleteMemberData({ userId }) {
    try {
      // Zugriff auf die Cloud Function
      const deleteMemberData = httpsCallable(this.functions, 'deleteMemberData');

      // Aufruf der Cloud Function mit den entsprechenden Daten
      const response = await deleteMemberData({ userId });

      if (response.data.success) {
        console.log(response.data.message);
        return response.data;
      } else {
        throw new Error(response.data.message || 'Failed to delete member data');
      }
    } catch (error) {
      console.error("Error in deleteMemberData:", error);
      throw error; // Fehler weitergeben
    }
  }

  
  /**********************************
  END USER ACTIONS
  **********************************/

  getPlans({ handler }) {
    onSnapshot(
      query(
        collection(this.db, "plans"),
        where('active', '==', true)
      ),
      docs => handler(docs)
    )
  }

  getSubscription({ userId, handler }) {
    // return this.db.collection('users')
    //   .doc(userId)
    //   // .doc('hP0NezbG42Mu7BaqiXQtyMBB1X93')
    //   .collection('subscriptions')
    //   .where('status', 'in', ['trialing', 'active'])
    //   .onSnapshot(onSnapshot)

      onSnapshot(
        query(
          collection(this.db, "users", userId, "subscriptions"),
          where('status', 'in', ['trialing', 'active'])
        ),
        docs => handler(docs)
      )

    }



  // const metadata = this.auth().getCurrentUser().getMetadata();
  // if (metadata.getCreationTimestamp() == metadata.getLastSignInTimestamp()) {
  //     // The user is new, show them a fancy intro screen!
  //     console.log("hello new user")
  // } else {
  //     // This is an existing user, show them a welcome back screen.
  //     console.log("welcome back screen")
  // }


  // async createTodo({todoInfo}){
  //   const createTodoCallable =
  //   this.functions.httpsCallable('createTodo');
  //   return createTodoCallable({
  //     todoInfo
  //   })
  // }


  createSettings({ companyname, organizationId, uid, logo, category, firstname, secondname, academictitlebefore, academictitleafter, street, city, zip, currency, bank, iban, bic, paypalmelink, tax, taxid, vatregnr, country, email, tel, emailtext, offerinfo, offerfooter, offerTemplate, invoiceinfo, invoicefooter, invoiceTemplate, websitelink, aiSupportMode, brandColor, accentColor, editableMode }){
    const createSettingsCallable = httpsCallable(this.functions, 'createSettings')
    return new Promise((resolve) => { 
      resolve(createSettingsCallable({
        companyname,
        organizationId,
        uid,
        logo,
        category,
        firstname,
        secondname,
        academictitlebefore,
        academictitleafter,
        street,
        city,
        zip,
        currency,
        bank,
        iban,
        bic,
        paypalmelink,
        tax,
        taxid,
        vatregnr,
        country,
        email,
        tel,
        emailtext,
        offerinfo,
        offerfooter,
        offerTemplate,
        invoiceinfo,
        invoicefooter,
        invoiceTemplate,
        websitelink,
        aiSupportMode,
        brandColor,
        accentColor,
        editableMode
      }))
    })
  }


  createNote({ organizationId, title, username}){
    const createNoteCallable = httpsCallable(this.functions, 'createNote')

    return new Promise((resolve) => {
      resolve(createNoteCallable({
        organizationId,
        title,
        username
      }))
    })
  }

  createCalendarEntry({ organizationId, title, start, end, description, location, allDay, username }){
    const createCalendarEntryCallable = httpsCallable(this.functions, 'createCalendarEntry')
    
    return new Promise((resolve) => {
      resolve(createCalendarEntryCallable({
        organizationId,
        title,
        start,
        end,
        description,
        location,
        allDay,
        username
      }))
    })
  }


  createCustomer({ businessCustomer, organizationId, companyname, customerno, academictitlebefore, academictitleafter, firstname, secondname, email, tel, street, city, zip, country, shippingAddress, shippingName, shippingStreet, shippingCity, shippingZip, shippingCountry, taxid, vatregnr, webaddress, note, contactPersons, username, active}){
    const createCustomerCallable = httpsCallable(this.functions, 'createCustomer')
    
    return new Promise((resolve) => {
      resolve(createCustomerCallable({
        businessCustomer,
        organizationId,
        companyname,
        customerno,
        academictitlebefore,
        academictitleafter,
        firstname,
        secondname,
        email,
        tel,
        street,
        city,
        zip,
        country,
        shippingAddress,
        shippingName,
        shippingStreet,
        shippingCity,
        shippingZip,
        shippingCountry,
        taxid,
        vatregnr,
        webaddress,
        note,
        contactPersons,
        username,
        active
      }))
    })
  }

  createSupplier({ organizationId, companyname, legalForm, supplierID, email, tel, street, city, zip, country, taxid, vatregnr, companyRegNr, bank, iban, bic, currency, webaddress, note, contactPersons, username, active}){
    const createCustomerCallable = httpsCallable(this.functions, 'createSupplier')
    
    return new Promise((resolve) => {
      resolve(createCustomerCallable({
        organizationId,
        companyname,
        legalForm,
        supplierID,
        email,
        tel,
        street,
        city,
        zip,
        country,
        taxid,
        vatregnr,
        companyRegNr,
        bank,
        iban,
        bic,
        currency,
        webaddress,
        note,
        contactPersons,
        username,
        active
      }))
    })
  }


  createArticle({ organizationId, title, description, isSupplierItem, supplier, articlenr, amount, unit, price, currency, taxpercentage, stockmanagement, stock, inventorylog, storageLocation, username }){
    const createArticleCallable = httpsCallable(this.functions, 'createArticle')
    return new Promise((resolve) => {
      resolve(createArticleCallable({
      organizationId,
      title,
      description,
      isSupplierItem,
      supplier,
      articlenr,
      amount,
      unit,
      price,
      currency,
      taxpercentage,
      stockmanagement,
      stock,
      inventorylog,
      storageLocation,
      username
    }))
  })
}


  createInvoice({ organizationId, lang, invoiceno, businessCustomer, customerno, companyname, academictitlebefore, academictitleafter, firstname, secondname, email, tel, street, city, zip, country, shippingAddress, shippingName, shippingStreet, shippingCity, shippingZip, shippingCountry, tax, taxid, vatregnr, orderNo, orderReference, orderRefDate, date, executionDate, deliveryDate, dueDate, payableWithin, recurringInvoice, recurringInterval, nextRecurringDate, remainingOccurrences, year, month, items, discount, shippingFee, cashDiscount, cashDiscountPeriod, currency, invoiceinfo, invoicefooter, note, username }){
    const createInvoiceCallable = httpsCallable(this.functions, 'createInvoice')
    
    return new Promise((resolve) => { 
      resolve(createInvoiceCallable({
        organizationId,
        lang,
        invoiceno,
        businessCustomer,
        customerno,
        companyname,
        academictitlebefore,
        academictitleafter,
        firstname,
        secondname,
        email,
        tel,
        street,
        city,
        zip,
        country,
        shippingAddress,
        shippingName,
        shippingStreet,
        shippingCity,
        shippingZip,
        shippingCountry,
        tax,
        taxid,
        vatregnr,
        orderNo,
        orderReference,
        orderRefDate,
        date,
        executionDate,
        deliveryDate,
        dueDate,
        payableWithin,
        recurringInvoice,
        recurringInterval,
        nextRecurringDate,
        remainingOccurrences,
        year,
        month,
        items,
        discount,
        shippingFee,
        cashDiscount,
        cashDiscountPeriod,
        currency,
        invoiceinfo,
        invoicefooter,
        note,
        username
      }))
    })
  }


  createOffer({ organizationId, lang, offerno, businessCustomer, customerno, companyname, academictitlebefore, academictitleafter, firstname, secondname, email, tel, street, city, zip, country, shippingAddress, shippingName, shippingStreet, shippingCity, shippingZip, shippingCountry, tax, taxid, vatregnr, date, expiryDate, year, month, items, discount, shippingFee, timestamp, currency, offerinfo, offerfooter, note, username }){
    const createOfferCallable = httpsCallable(this.functions, 'createOffer')
    
    return new Promise((resolve) => {
      resolve(createOfferCallable({
        organizationId,
        lang,
        offerno,
        businessCustomer,
        customerno,
        companyname,
        academictitlebefore,
        academictitleafter,
        firstname,
        secondname,
        email,
        tel,
        street,
        city,
        zip,
        country,
        shippingAddress,
        shippingName,
        shippingStreet,
        shippingCity,
        shippingZip,
        shippingCountry,
        tax,
        taxid,
        vatregnr,
        date,
        expiryDate,
        year,
        month,
        items,
        discount,
        shippingFee,
        timestamp,
        currency,
        offerinfo,
        offerfooter,
        note,
        username
      }))
    })
  }

  createOrder({ organizationId, lang, orderno, supplierID, companyname, academictitlebefore, academictitleafter, firstname, secondname, email, tel, street, city, zip, country, shippingAddress, shippingName, shippingStreet, shippingCity, shippingZip, shippingCountry, tax, taxid, vatregnr, orderRefDate, date, deliveryDate, payableWithin, recurringOrder, recurringInterval, nextRecurringDate, remainingOccurrences, year, month, items, discount, shippingFee, displayPrices, currency, orderinfo, orderfooter, note, username }){
    const createOrderCallable = httpsCallable(this.functions, 'createOrder')
    
    return new Promise((resolve) => { 
      resolve(createOrderCallable({
        organizationId,
        lang,
        orderno,
        supplierID,
        companyname,
        academictitlebefore,
        academictitleafter,
        firstname,
        secondname,
        email,
        tel,
        street,
        city,
        zip,
        country,
        shippingAddress,
        shippingName,
        shippingStreet,
        shippingCity,
        shippingZip,
        shippingCountry,
        tax,
        taxid,
        vatregnr,
        orderRefDate,
        date,
        deliveryDate,
        payableWithin,
        recurringOrder,
        recurringInterval,
        nextRecurringDate,
        remainingOccurrences,
        year,
        month,
        items,
        discount,
        shippingFee,
        displayPrices,
        currency,
        orderinfo,
        orderfooter,
        note,
        username
      }))
    })
  }

  // async createEarning({ title, description, customer, invoiceno, percentage, amount, date, year, month, cancelled }){
  //   const createEarningCallable =
  //   this.functions.httpsCallable('createEarning')
  //   return createEarningCallable({
  //     title,
  //     description,
  //     customer,
  //     invoiceno,
  //     percentage,
  //     amount,
  //     date,
  //     year,
  //     month,
  //     cancelled
  //   })
  // }

  createExpense({ organizationId, lang, orderNo, category, supplierID, companyname, academictitlebefore, academictitleafter, firstname, secondname, email, tel, street, city, zip, country, invoiceno, date, year, month, items, tax, discount, cashDiscount, cashDiscountPeriod, shippingFee, currency, payed, payableWithin, dueDate, recurringExpense, recurringInterval, nextRecurringDate, remainingOccurrences, note, cancelled, username }){
    const createExpenseCallable = httpsCallable(this.functions, 'createExpense')

    return new Promise((resolve) => {
      resolve(createExpenseCallable({
        organizationId,
        lang,
        orderNo,
        category,
        supplierID,
        companyname,
        academictitlebefore,
        academictitleafter,
        firstname,
        secondname,
        email,
        tel,
        street,
        city,
        zip,
        country,
        invoiceno,
        date,
        year,
        month,
        items,
        tax,
        discount,
        cashDiscount,
        cashDiscountPeriod,
        shippingFee,
        currency,
        payed,
        payableWithin,
        dueDate,
        recurringExpense,
        recurringInterval,
        nextRecurringDate,
        remainingOccurrences,
        note,
        cancelled,
        username
      }))
    })
  }

  async getExpenseDetails({ id, handler }) {
    onSnapshot(
      query(
        doc(this.db, 'expenses', id)
      ),
      docs => handler(docs)
    )
  }

  async updateExpenseField({ expenseId, field, value, lastEdit, lastEditBy }) {
    if (!expenseId || !field) {
      console.error("Invalid update request: Missing expenseId or field.");
      return;
    }
  
    try {
      const expenseRef = doc(this.db, "expenses", expenseId);
  
        await updateDoc(expenseRef, {
          [field]: value,
          lastEdit,
          lastEditBy,
        });
        console.log(`Updated ${field} for expense ${expenseId}`);
      
    } catch (error) {
      console.error("Update failed:", error);
    }
  }

  async appendExpensePositions({expenseId, items, lastEdit, lastEditBy}){
    // console.log(items)
    const data = {
        "amount": items[0].amount,
        "articlenr": items[0].articlenr,
        "description": items[0].description,
        "itemtitle": items[0].itemtitle,
        "price": items[0].price,
        "taxpercentage": items[0].taxpercentage,
        // "total": items[0].total,
        "unit": items[0].unit,
        "id": items[0].id
    };

    let expenseRef = doc(this.db, "expenses", expenseId)

    await updateDoc(expenseRef, {
      items: arrayUnion(data),
      lastEdit: lastEdit,
      lastEditBy: lastEditBy,
    })
  }

  // CLEAN VERSION
  async updateExpensePosition({expenseId, invoiceItems, lastEdit, lastEditBy}){
    

    //Grab through reference all comments Array in firestore
    let actualPosition = invoiceItems
    // console.log(invoiceId)

    let expenseRef = doc(this.db, "expenses", expenseId)

    await updateDoc(expenseRef, {
      items: actualPosition,
      lastEdit: lastEdit,
      lastEditBy: lastEditBy,
    })
  }

  async deleteExpensePosition({expenseId, item}){
    let expenseRef = doc(this.db, "expenses", expenseId)
    await updateDoc(expenseRef , {
     items: arrayRemove(item)
    })
    .catch(function(error) {
      console.error("Error removing document: ", error);
    });
  }

  // async updateExpenseDate({expenseId, date, year, month, lastEdit, lastEditBy}){
  //   const data = {
  //       date,
  //       month,
  //       year,
  //       lastEdit,
  //       lastEditBy
  //   };
  //   const expenseRef = doc(this.db, 'expenses', expenseId)

  //   await setDoc(
  //     expenseRef, data,
  //     {merge: true }
  //   ).then(() => {
  //     console.log("Updated expense");
  //   })
  //   .catch((error) => {
  //     console.error(error);
  //   });
  // }

  async updateExpenseDate({expenseId, date, dueDate, year, month, lastEdit, lastEditBy }){
    const data = {
        date,
        dueDate,
        year,
        month,
        lastEdit,
        lastEditBy,

    };
    const expenseRef = doc(this.db, 'expenses', expenseId)
    await setDoc(
      expenseRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated expense");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  async updateExpensePayableWithin({expenseId, payableWithin, dueDate, lastEdit, lastEditBy}){
    const data = {
        payableWithin,
        dueDate,
        lastEdit,
        lastEditBy
    };
    const expenseRef = doc(this.db, 'expenses', expenseId)
    await setDoc(
      expenseRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated expense");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  // async updateExpensePayed({expenseId, payed, lastEdit, lastEditBy}){
  //   const data = {
  //       payed,
  //       lastEdit,
  //       lastEditBy
  //   };
  //   const expenseRef = doc(this.db, 'expenses', expenseId)

  //   await setDoc(
  //     expenseRef, data,
  //     { merge: true }
  //   ).then(() => {
  //     console.log("Updated expense");
  //   })
  //   .catch((error) => {
  //     console.error(error);
  //   });
  // }

  async updateExpensePayed({expenseId, payed, payedWithCashDiscount, paymentDate, note, lastEdit, lastEditBy}){
    const data = {
        payed,
        payedWithCashDiscount,
        paymentDate,
        note,
        lastEdit,
        lastEditBy
    };
    const expenseRef = doc(this.db, 'expenses', expenseId)
    await setDoc(
      expenseRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated expense");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  async updateRecurringExpenseMode({ expenseId, recurringExpense, remainingOccurrences, nextRecurringDate, lastEdit, lastEditBy }) {
    console.log('Next Recurring Date: ' + nextRecurringDate)
    // Normalisiere `remainingOccurrences`
    const normalizedRemainingOccurrences = typeof remainingOccurrences === 'number'
        ? remainingOccurrences
        : parseFloat(remainingOccurrences) || -1;

    const data = {
        recurringExpense,
        remainingOccurrences: normalizedRemainingOccurrences,
        lastEdit,
        lastEditBy,
    };

    // Bestellung von `nextRecurringDate`, falls es nicht übergeben wurde
    if (recurringExpense) {
        // Wenn `nextRecurringDate` übergeben wird, setze es
        if (nextRecurringDate) {
            data.nextRecurringDate = nextRecurringDate;
        }
        // Standardwert für `recurringInterval` setzen, falls es nicht gesetzt wurde
        if (!data.recurringInterval) {
          data.recurringInterval = 'yearly'; // Standardwert für Intervall setzen
        }
    } else {
        // Setze Felder zurück, wenn wiederkehrend deaktiviert wird
        data.remainingOccurrences = deleteField();
        data.nextRecurringDate = deleteField();
        data.recurringInterval = deleteField();
    }

    const expenseRef = doc(this.db, 'expenses', expenseId);

    try {
        // Speichern der Daten in der Datenbank
        await setDoc(expenseRef, data, { merge: true });
        console.log('Updated expense in database:', data);
    } catch (error) {
        console.error('Error updating order:', error);
    }
  }

  async updateRecurringExpenseInterval({expenseId, recurringInterval, nextRecurringDate, lastEdit, lastEditBy}){
    const data = {
        recurringInterval,
        nextRecurringDate,
        lastEdit,
        lastEditBy
    };
    const expenseRef = doc(this.db, 'expenses', expenseId)
    await setDoc(
      expenseRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated expense");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  async updateRemainingExpenseOccurrences({expenseId, remainingOccurrences, lastEdit, lastEditBy}){
    const data = {
        // remainingOccurrences,
        // remainingOccurrences: typeof remainingOccurrences === 'number' ? remainingOccurrences : parseFloat(remainingOccurrences), // Ensure number type
        remainingOccurrences: typeof remainingOccurrences === 'number'
          ? remainingOccurrences
          : parseFloat(remainingOccurrences) || -1,
        lastEdit,
        lastEditBy
    };
    const expenseRef = doc(this.db, 'expenses', expenseId)
    await setDoc(
      expenseRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated expense");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  /*****************************
  END EXPENSES
  *****************************/


  /*****************************
  Search Todos with ut8ff
  *****************************/
  // searchTodos({ user, onSnapshot, keyword }) {
  //   return this.db.collection('todos')
  //     .where('user', '==', user)
  //     // .where('title', '==', keyword)
  //     // .where('title', 'array-contains', keyword)
  //     // .where('title', 'array-contains', keyword+ '\uf8ff')
  //     // .where('title', '>=', keyword)
  //     // .where('title', '<=', keyword)
  //     // .limit(10)
  //
  //     .where('title', '>=', keyword).where('title', '<=', keyword+ '\uf8ff')
  //
  //     // .orderBy('title').startAt(keyword).endAt(keyword + '~')
  //
  //     // .orderBy('dataCreated', 'desc')
  //     .onSnapshot(onSnapshot)
  // }
  /*****************************
  END Search Todos with ut8ff
  *****************************/

    // GET Latest todos WITH LIVE UPDATE
    getLatestTodos ({ userId, handler }) {
      onSnapshot(
        query(
          collection(this.db, "todos"),
          // where('user', '==', user),
          where('uid', '==', userId),
          orderBy('lastEdit', 'desc'),
          limit(3)
        ),
        docs => handler(docs)
      )
    }

    // GET PINNED Todos WITH LIVE UPDATE
  getPinnedTodos ({ userId, handler }) {
    onSnapshot(
      query(
        collection(this.db, "todos"),
        where('isPinned', '==', true),
        where('uid', '==', userId),
        orderBy('lastEdit', 'desc'),
        limit(50)
      ),
      docs => handler(docs)
    )
  }

  
  async getTodos({ userId, resetCursor = false }) {
    const cursorKey = `todos:${userId}`
    if (resetCursor) {
      delete this.paginationCursors[cursorKey]
    }
    const cursor = this.paginationCursors[cursorKey]
    const constraints = [
      where('uid', '==', userId),
      orderBy('lastEdit'),
    ]

    if (cursor) {
      constraints.push(startAfter(cursor))
    }

    constraints.push(limit(2))

    const ref = query(
      collection(this.db, 'todos'),
      ...constraints
    )

      const data = await getDocs(ref)

      if (!data.empty) {
        this.paginationCursors[cursorKey] = data.docs[data.docs.length - 1]
      }

      return data   
  }



  


  // async getNextTodos ({ user, onSnapshot }) {
  //   // var todos = []
  //   // var listeners = []    // list of listeners
  //   // var start = null      // start position of listener
  //   // var end = null
  //
  //   // return this.db.collection('todos')
  //   //   .where('user', '===', user)
  //
  //
  //   let ref = this.db.collection('todos')
  //   // single query to get new startAt snapshot
  //   ref.orderBy('dataCreated', 'desc')
  //   .where('user', '==', user)
  //   .startAt(this.start || 0)
  //   .limit(3).get()
  //   .then((snapshots) => {
  //    // previous starting boundary becomes new ending boundary
  //     this.end = this.start
  //     this.start = snapshots.docs[snapshots.docs.length - 1]
  //     // create another listener using new boundaries
  //     let listener = ref.orderBy('dataCreated')
  //       .where('user', '==', user)
  //       .startAt(this.start || 0)
  //       .endBefore(this.end || 0)
  //     // .onSnapshot((todos) => {
  //     //   todos.forEach((todo) => {
  //     //     todos = todos.filter(x => x.id !== todo.id)
  //     //     todos.push(todo.data())
  //     //   })
  //     // })
  //     .onSnapshot(onSnapshot)
  //
  //     // this.listeners.push(listener)
  //   })
  //
  // }






  // async getNextTodos ({ user, onSnapshot }) {
  //   // var todos = []
  //   // var listeners = []    // list of listeners
  //   // var start = null      // start position of listener
  //   // var end = null
  //
  //   // return this.db.collection('todos')
  //   //   .where('user', '===', user)
  //
  //
  //
  //   let ref = this.db.collection('todos')
  //   // single query to get new startAt snapshot
  //   ref.orderBy('dataCreated', 'desc')
  //   .startAfter(this.latestDoc || 0)
  //   .limit(3).get()
  //   .then((snapshots) => {
  //    // previous starting boundary becomes new ending boundary
  //     // this.end = this.start
  //     // this.start = snapshots.docs[snapshots.docs.length - 1]
  //     // create another listener using new boundaries
  //     // let listener = ref.orderBy('dataCreated')
  //     let listener = ref.orderBy('dataCreated')
  //     // .startAt(this.start).endBefore(this.end)
  //     // .onSnapshot((todos) => {
  //     //   todos.forEach((todo) => {
  //     //     todos = todos.filter(x => x.id !== todo.id)
  //     //     todos.push(todo.data())
  //     //   })
  //     // })
  //     .onSnapshot(onSnapshot)
  //
  //     // this.listeners.push(listener)
  //     this.latestDoc = snapshots.docs[snapshots.docs.length - 1]
  //   })
  //
  // }


  // async getNextTodos ({ user, onSnapshot }) {
  //
  //   var first = this.db.collection("todos")
  //       // .where('user', '==', user)
  //       .orderBy("dataCreated", "desc")
  //       .limit(5)
  //
  //   var next = this.db.collection("todos")
  //
  //   await first.get().then(function (documentSnapshots) {
  //     // Get the last visible document
  //     var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length-1];
  //     console.log("last", lastVisible);
  //
  //     // Construct a new query starting at this document,
  //     // get the next 25 cities.
  //     next
  //             // .where('user', '==', user)
  //             .orderBy("dataCreated", "desc")
  //             .startAfter(lastVisible)
  //             .limit(2)
  //             .onSnapshot(onSnapshot)
  //   });
  // }


  // async getNextTodos ({ user, onSnapshot }) {
  //
  //   const ref = this.db.collection("todos")
  //     .orderBy("dataCreated", 'desc')
  //     .startAfter(this.latestDoc || 0)
  //     .limit(5)
  //     // .onSnapshot(onSnapshot)
  //
  //   const data = await ref.get()
  //
  //   this.latestDoc = data.docs[data.docs.length -1]
  //
  //   // var first = this.db.collection("todos")
  //   //     // .where('user', '==', user)
  //   //     .orderBy("dataCreated", 'desc')
  //   //     .limit(5);
  //   //
  //   // var next = this.db.collection("todos")
  //   //
  //   // return first.get().then(function (documentSnapshots) {
  //   //   // Get the last visible document
  //   //   var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length-1];
  //   //   console.log("last", lastVisible);
  //   //
  //   //   // Construct a new query starting at this document,
  //   //   // get the next 25 cities.
  //   //   next
  //   //           // .where('user', '==', user)
  //   //           .orderBy("dataCreated", 'desc')
  //   //           .startAfter(lastVisible)
  //   //           .limit(3)
  //   //           .onSnapshot(onSnapshot)
  //   // });
  // }

  // getNextTodos ({ user, onSnapshot }) {
  //
  //   const ref = this.db.collection("todos")
  //     .orderBy("dataCreated", 'desc')
  //     .startAfter(this.latestDoc || 0)
  //     .limit(5)
  //     // .onSnapshot(onSnapshot)
  //
  //   const data = ref.get()
  //
  //   return ref.get().then(function (documentSnapshots) {
  //     // Get the last visible document
  //     this.latestDoc = documentSnapshots.docs[documentSnapshots.docs.length-1];
  //
  //
  //     // Construct a new query starting at this document,
  //     // get the next 25 cities.
  //     data
  //             // .where('user', '==', user)
  //             .orderBy("dataCreated", 'desc')
  //             .startAfter(this.latestDoc || 0)
  //             .limit(3)
  //             .onSnapshot(onSnapshot)
  //   })
  //
  //   this.latestDoc = data.docs[data.docs.length -1]
  //   // this.latestDoc = documentSnapshots.docs[documentSnapshots.docs.length-1]
  //
  //
  //   // var first = this.db.collection("todos")
  //   //     // .where('user', '==', user)
  //   //     .orderBy("dataCreated", 'desc')
  //   //     .limit(5);
  //   //
  //   // var next = this.db.collection("todos")
  //   //
  //   // return first.get().then(function (documentSnapshots) {
  //   //   // Get the last visible document
  //   //   var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length-1];
  //   //   console.log("last", lastVisible);
  //   //
  //   //   // Construct a new query starting at this document,
  //   //   // get the next 25 cities.
  //   //   next
  //   //           // .where('user', '==', user)
  //   //           .orderBy("dataCreated", 'desc')
  //   //           .startAfter(lastVisible)
  //   //           .limit(3)
  //   //           .onSnapshot(onSnapshot)
  //   // });
  //
  // }


  // getNextTodos ({ user, onSnapshot }) {
  //
  //   var first = this.db.collection("todos")
  //     .orderBy('dataCreated', "desc")
  //     .limit(2)
  //
  //   var next = this.db.collection("todos")
  //
  //   return first.onSnapshot(function(querySnapshot) {
  //   // Get the last visible document
  //   // var lastVisible = querySnapshot
  //   var lastVisible = querySnapshot.docs[querySnapshot.docs.length-1];
  //   // console.log("last", lastVisible);
  //
  //   // Construct a new query starting at this document,
  //   // get the next 25 cities.
  //   // var next = this.db.collection("invoices")
  //   // let next = this.db.collection('invoices')
  //           next
  //           // .where('user', '==', user)
  //           .orderBy("dataCreated", "desc")
  //           // .startAfter(3)
  //           // .startAfter(5)
  //           .startAfter(lastVisible)
  //           .limit(2)
  //           // .offset(20)
  //           .onSnapshot(onSnapshot)
  //           // .querySnapshot(querySnapshot)
  //   });
  // }




  /********************************
  NOTES START
  ********************************/
  // // GET NOTES WITH LIVE UPDATE
  // getNotes ({ user, onSnapshot }) {
  //   return this.db.collection('notes')
  //     .where('user', '==', user)
  //     .orderBy('dataCreated', 'desc')
  //     .onSnapshot(onSnapshot)
  // }

  // getNotes({ user, onSnapshot }) {
  //   // query reference for the notes we want
  //   let ref = this.db.collection('notes')
  //   // single query to get startAt snapshot
  //   ref.orderBy('dataCreated', 'desc')
  //   .where('user', '==', user)
  //   .limit(2).get()
  //   .then((snapshots) => {
  //   // save startAt snapshot
  //   this.start = snapshots.docs[snapshots.docs.length - 1]
  //   // create listener using startAt snapshot (starting boundary)
  //   let listener = ref.orderBy('dataCreated')
  //     .where('user', '==', user)
  //     .startAt(this.start || 0)
  //     .onSnapshot(onSnapshot)
  //   })
  // }

  // GET LATEST NOTES WITH LIVE UPDATE
  getLatestNotes ({ userId, handler }) {
    onSnapshot(
      query(
        collection(this.db, "notes"),
        // where('user', '==', user),
        where('uid', '==', userId),
        orderBy('lastEdit', 'desc'),
        limit(3)
      ),
      docs => handler(docs)
    )
  }

  async getNotes({ userId, resetCursor = false }) {
    const cursorKey = `notes:${userId}`
    if (resetCursor) {
      delete this.paginationCursors[cursorKey]
    }
    const cursor = this.paginationCursors[cursorKey]
    const constraints = [
      where('uid', '==', userId),
      orderBy('lastEdit'),
    ]

    if (cursor) {
      constraints.push(startAfter(cursor))
    }

    constraints.push(limit(2))

    const ref = query(
      collection(this.db, 'notes'),
      ...constraints
    )

    const data = await getDocs(ref)

    if (!data.empty) {
      this.paginationCursors[cursorKey] = data.docs[data.docs.length - 1]
    }

    return data
  }

  // GET PINNED NOTES WITH LIVE UPDATE
  getPinnedNotes ({ userId, handler }) {
    onSnapshot(
      query(
        collection(this.db, "notes"),
        where('isPinned', '==', true),
        where('uid', '==', userId),
        orderBy('lastEdit', 'desc'),
        limit(50)
      ),
      docs => handler(docs)
    )
  }

  // searchNotes({ user, onSnapshot, keyword }) {
  //   return this.db.collection('notes')
  //     .where('user', '==', user)
  //     .orderBy('title')
  //     .startAt(keyword)
  //     .endAt(keyword + '\uf8ff')
  //     .limit(5)
  //     .onSnapshot(onSnapshot)
  // }

  async updateNote({noteId, title, lastEdit, lastEditBy}){
    const data = {
        title,
        lastEdit,
        lastEditBy
    };
    const noteRef = doc(this.db, 'notes', noteId)

    await setDoc(
      noteRef, data,
      {merge: true }
    ).then(() => {
      console.log("Updated note")
    })
    .catch((error) => {
      console.log(error)
    })
  }

  async updateNotePinState(noteId, isPinned, lastEdit, lastEditBy) {
    // Debugging-Ausgabe
    // console.log('Updating note with ID:', noteId);
    // console.log('Pin status:', isPinned);
    // console.log('Last edited on:', lastEdit);
    // console.log('Last edited by:', lastEditBy);

    try {
      const data = {
        isPinned,
        lastEdit,
        lastEditBy
      }
      const noteRef = doc(this.db, 'notes', noteId);
      
      await setDoc(
        noteRef, data, { merge: true });
      console.log('Note updated');
    } catch (error) {
      console.error('Error updating pin status: ', error);
    }
  }
  /********************************
  NOTES END
  ********************************/

  /********************************
  CALENDAR START
  ********************************/
  getTodaysUpcomingCalendarentriesByOrganization({ organizationId, date, time, handler }) {
    const today = date ? new Date(date) : new Date()
    const startOfDay = new Date(today)
    startOfDay.setHours(0, 0, 0, 0)
    const endOfDay = new Date(today)
    endOfDay.setHours(23, 59, 59, 999)

    return onSnapshot(
      query(
        collection(this.db, 'calendarentries'),
        where('organizationId', '==', organizationId),
        where('start', '>=', startOfDay.toISOString()),
        where('start', '<=', endOfDay.toISOString())
      ),
      docs => handler(docs.size),
      error => {
        console.error('Error fetching calendar entries:', error)
        handler(0)
      }
    )
  }
  

  getTodaysUpcomingCalendarentriesByUser ({ userId, date, time, handler }) {
    const today = date ? new Date(date) : new Date()
    const startOfDay = new Date(today)
    startOfDay.setHours(0, 0, 0, 0)
    const endOfDay = new Date(today)
    endOfDay.setHours(23, 59, 59, 999)

    return onSnapshot(
      query(
        collection(this.db, 'calendarentries'),
        where('uid', '==', userId),
        where('start', '>=', startOfDay.toISOString()),
        where('start', '<=', endOfDay.toISOString())
      ),
      docs => handler(docs.size),
      error => {
        console.error('Error fetching calendar entries:', error)
        handler(0)
      }
    )
  }

  // getTodaysCalendarentries({ userId, start, end, handler }) {
  //   onSnapshot(
  //     query(
  //       collection(this.db, "calendarentries"),
  //       where('uid', '==', userId),
  //       where('date', '>=', start), // Start des Tages
  //       where('date', '<=', end)   // Ende des Tages
  //     ),
  //     (docs) => handler(docs)
  //   );
  // }

  // getTodaysCalendarentriesByOrganization({ organizationId, start, end, handler }) {
  //   onSnapshot(
  //     query(
  //       collection(this.db, "calendarentries"),
  //       where('organizationId', '==', organizationId),
  //       where('date', '>=', start), // Start des Tages
  //       where('date', '<=', end)   // Ende des Tages
  //     ),
  //     (docs) => handler(docs)
  //   );
  // }

  
  // getTomorrowsCalendarentries({ userId, start, end, handler }) {
  //   onSnapshot(
  //     query(
  //       collection(this.db, "calendarentries"),
  //       where('uid', '==', userId),
  //       where('date', '>=', start), // Start des Tages
  //       where('date', '<=', end)   // Ende des Tages
  //     ),
  //     (docs) => handler(docs)
  //   );
  // }

  // getTomorrowsCalendarentriesByOrganization({ organizationId, start, end, handler }) {
  //   onSnapshot(
  //     query(
  //       collection(this.db, "calendarentries"),
  //       where('organizationId', '==', organizationId),
  //       where('date', '>=', start), // Start des Tages
  //       where('date', '<=', end)   // Ende des Tages
  //     ),
  //     (docs) => handler(docs)
  //   );
  // }

  // getCalendarentriesByDate ({ userId, date, handler }) {
  //   onSnapshot(
  //     query(
  //       collection(this.db, "calendarentries"),
  //       // where('user', '==', user),
  //       where('uid', '==', userId),
  //       where('date', '==', date)
  //     ),
  //     docs => handler(docs)
  //   )
  // }



  // getCalendarentriesByDateAndOrganization ({ organizationId, date, handler }) {
  //   onSnapshot(
  //     query(
  //       collection(this.db, "calendarentries"),
  //       where('organizationId', '==', organizationId),
  //       where('date', '==', date)
  //     ),
  //     docs => handler(docs)
  //   )
  // }


  

  getCalendarentriesByDate({ userId, start, end, handler }) {
    onSnapshot(
      query(
        collection(this.db, 'calendarentries'),
        where('uid', '==', userId),
        where('start', '>=', start),
        where('end', '<=', end)
      ),
      (docs) => handler(docs)
    );
  }
  
  getCalendarentriesByDateAndOrganization({ organizationId, start, end, handler }) {
    onSnapshot(
      query(
        collection(this.db, 'calendarentries'),
        where('organizationId', '==', organizationId),
        where('start', '>=', start),
        where('end', '<=', end)
      ),
      (docs) => handler(docs)
    );
  }
  


  // searchCalendarentriesByDate({ user, onSnapshot, keyword }) {
  //   return this.db.collection('calendarentries')
  //     .where('user', '==', user)
  //     .where('date', '>=', keyword).where('date', '<=', keyword+ '\uf8ff')
  //     // .where('date', '==', keyword)
  //     // .where('date', '>=', date).where('date', '<=', date+ '\uf8ff')
  //     // .orderBy('title').startAt(keyword).endAt(keyword + '~')
  //     .onSnapshot(onSnapshot)
  // }
  /********************************
  CALENDAR END
  ********************************/

  /********************************
  CUSTOMERS START
  ********************************/
  // GET ALL CUSTOMERS WITH LIVE UPDATE FOR CSV EXPORT
  getAllCustomers ({ organizationId, handler }) {
    onSnapshot(
      query(
        collection(this.db, "customers"),
        where('organizationId', '==', organizationId)
        // where('user', '==', user)
      ),
      docs => handler(docs)
    )
  }

  // GET CUSTOMERS WITH LIVE UPDATE
  getLiveCustomers ({ organizationId, handler }) {
    onSnapshot(
      query(
        collection(this.db, "customers"),
        where('organizationId', '==', organizationId),
        // where('user', '==', user)
      ),
      docs => handler(docs)
    )
  }

  // GET LATEST CUSTOMERS WITH LIVE UPDATE
  getLatestCustomers ({ organizationId, handler }) {
    onSnapshot(
      query(
        collection(this.db, "customers"),
        // where('user', '==', user),
        where('organizationId', '==', organizationId),
        orderBy('dataCreated', 'desc'),
        limit(3)
      ),
      docs => handler(docs)
    )
  }

  async getCustomers({ organizationId, resetCursor = false }) {
    const cursorKey = `customers:${organizationId}`
    if (resetCursor) {
      delete this.paginationCursors[cursorKey]
    }
    const cursor = this.paginationCursors[cursorKey]
    const constraints = [
      where('organizationId', '==', organizationId),
      orderBy('dataCreated'),
    ]

    if (cursor) {
      constraints.push(startAfter(cursor))
    }

    constraints.push(limit(2))

    const ref = query(
      collection(this.db, 'customers'),
      ...constraints
    )

      const data = await getDocs(ref)

      if (!data.empty) {
        this.paginationCursors[cursorKey] = data.docs[data.docs.length - 1]
      }

      return data
  }

  async getAllCustomersByOrganization(organizationId) {
    try {
      const querySnapshot = await getDocs(
        query(
          collection(this.db, "customers"),
          where('organizationId', '==', organizationId)
        )
      );
  
      return querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
    } catch (error) {
      console.error("Fehler beim Abrufen der Kunden:", error);
      throw error;
    }
  }
  


  // async getAllActiveCustomersByOrganization({ organizationId, handler }) {
  //   const customersCol = collection(this.db, 'customers')
  //   const customersQuery = query(
  //     customersCol,
  //       where('organizationId', '==', organizationId),
  //       where('active', '==', true)
  //     )

  //     const snapshot = await getCountFromServer(customersQuery)
      
  //     return handler(snapshot.data().count)
  // }

  // async getAllInactiveCustomersByOrganization({ organizationId, handler }) {
  //   const customersCol = collection(this.db, 'customers')
  //   const customersQuery = query(
  //     customersCol,
  //       where('organizationId', '==', organizationId),
  //       where('active', '==', false)
  //     )

  //     const snapshot = await getCountFromServer(customersQuery)
      
  //     return handler(snapshot.data().count)
  // }


  /********************************
  CUSTOMERS END
  ********************************/


  /********************************
  SUPPLIERS START
  ********************************/

  getAllSuppliers({ organizationId, handler }) {
    onSnapshot(
      query(
        collection(this.db, "suppliers"),
        where('organizationId', '==', organizationId)
        // where('user', '==', user)
      ),
      docs => handler(docs)
    )
  }

  getLiveSuppliers ({ organizationId, handler }) {
    onSnapshot(
      query(
        collection(this.db, "suppliers"),
        where('organizationId', '==', organizationId),
        // where('user', '==', user)
      ),
      docs => handler(docs)
    )
  }

  // GET LATEST CUSTOMERS WITH LIVE UPDATE
  getLatestSuppliers ({ organizationId, handler }) {
    onSnapshot(
      query(
        collection(this.db, "suppliers"),
        // where('user', '==', user),
        where('organizationId', '==', organizationId),
        orderBy('dataCreated', 'desc'),
        limit(3)
      ),
      docs => handler(docs)
    )
  }

  async getSuppliers({ organizationId }) {
    // var lastItem = null
  const ref = query(collection(this.db, 'suppliers'),
    // where('user', '==', user),
    where('organizationId', '==', organizationId),
    orderBy('dataCreated'),
    startAfter(this.latestDoc || 0),
    limit(2)
  )

    const data = await getDocs(ref)

    this.latestDoc = data.docs[data.docs.length - 1]

    return data
}

async getAllSuppliersByOrganization(organizationId) {
  try {
    const querySnapshot = await getDocs(
      query(
        collection(this.db, "suppliers"),
        where('organizationId', '==', organizationId)
      )
    );

    return querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));
  } catch (error) {
    console.error("Fehler beim Abrufen der Lieferanten:", error);
    throw error;
  }
}

async appendSupplierContactPerson({supplierId, newContactPerson, lastEdit, lastEditBy}){
  // console.log(newContactPerson)
  // console.log(newContactPerson.academictitlebefore)
  const data = {
      "academictitlebefore": newContactPerson.academictitlebefore,
      "academictitleafter": newContactPerson.academictitleafter,
      "firstname": newContactPerson.firstname,
      "secondname": newContactPerson.secondname,
      "email": newContactPerson.email,
      "tel": newContactPerson.tel,
      "note": newContactPerson.note,
  };

  let supplierRef = doc(this.db, "suppliers", supplierId)

  await updateDoc(supplierRef, {
    contactPersons: arrayUnion(data),
    lastEdit: lastEdit,
    lastEditBy: lastEditBy,
  })
}

async deleteSupplier({supplierId}){
  const supplierRef = doc(this.db, 'suppliers', supplierId)

  await deleteDoc(supplierRef)
  .then(() => {
    console.log("Supplier deleted")
  })
  .catch((error) => {
    console.error(error);
  })
}

async deleteSupplierContactPerson({ supplierId, person }) {
  let supplierRef = doc(this.db, "suppliers", supplierId);
  
  try {
    await updateDoc(supplierRef, {
      contactPersons: arrayRemove(person)
    });
    console.log('Contact person succesfully deleted');
  } catch (error) {
    console.error("Delete failed: ", error);
    throw error;
  }
}


async updateSupplierField({ supplierId, field, value, lastEdit, lastEditBy }) {
  if (!supplierId || !field) {
    console.error("Invalid update request: Missing supplierId or field.");
    return;
  }

  try {
    const supplierRef = doc(this.db, "suppliers", supplierId);

    // Falls das zu aktualisierende Feld Teil eines Arrays ist
    if (field.startsWith("contactPersons.")) {
      // Extrahiere den Index aus dem Feldnamen (z.B. contactPersons.0.academictitlebefore)
      const match = field.match(/^contactPersons\.(\d+)\.(.+)$/);
      if (!match) {
        console.error("Invalid field format for array update.");
        return;
      }

      const index = parseInt(match[1], 10); // Index des Arrays
      const subField = match[2]; // Das eigentliche Feld, das aktualisiert werden soll

      // Lade den aktuellen Lieferanten aus der Datenbank
      const supplierDoc = await getDoc(supplierRef);
      if (!supplierDoc.exists()) {
        console.error("Supplier not found");
        return;
      }

      const supplierData = supplierDoc.data();

      // Prüfe, ob `contactPersons` existiert und der Index gültig ist
      if (!supplierData.contactPersons || !supplierData.contactPersons[index]) {
        console.error("Invalid contact person index");
        return;
      }

      // Erstelle eine Kopie des Arrays und aktualisiere das gewünschte Feld
      const updatedContactPersons = [...supplierData.contactPersons];
      updatedContactPersons[index] = {
        ...updatedContactPersons[index],
        [subField]: value,
      };

      // Update in Firestore
      await updateDoc(supplierRef, {
        contactPersons: updatedContactPersons,
        lastEdit,
        lastEditBy,
      });

      console.log(`Updated ${field} for supplier ${supplierId}`);
    } else {
      // Falls das Feld kein Array ist, normal aktualisieren
      await updateDoc(supplierRef, {
        [field]: value,
        lastEdit,
        lastEditBy,
      });
      console.log(`Updated ${field} for supplier ${supplierId}`);
    }
  } catch (error) {
    console.error("Update failed:", error);
  }
}

  
  /********************************
  SUPPLIERS END
  ********************************/

/********************************
  ORDERS START
  ********************************/
  getLatestOrganizationOrders ({ organizationId, handler }) {
    onSnapshot(
      query(
        collection(this.db, "orders"),
        where("organizationId", "==", organizationId),
        orderBy('dataCreated', 'desc'),
        limit(3)
      ),
      docs => handler(docs)
    )
  }

  getLatestOrders ({ userId, handler }) {
    onSnapshot(
      query(
        collection(this.db, "orders"),
        where("uid", "==", userId),
        orderBy('dataCreated', 'desc'),
        limit(3)
      ),
      docs => handler(docs)
    )
  }

  getOrganizationOrdersByDate({ organizationId, year, month, supplier, teammember, handler }) {
    const queryConstraints = [
      where('organizationId', '==', organizationId),
      where('year', '==', year)
    ];
  
    if (month !== '-') {
      queryConstraints.push(where('month', '==', month));
    }
    if (supplier !== '-') {
      queryConstraints.push(where('companyname', '==', supplier));
    }
    if (teammember !== '-') {
      queryConstraints.push(where('uid', '==', teammember));
    }
  
    onSnapshot(
      query(
        collection(this.db, "orders"),
        ...queryConstraints
      ),
      docs => handler(docs)
    );
  }

  getOrdersByDate({ userId, year, month, supplier, handler }) {
    const queryConstraints = [
      where('uid', '==', userId),
      where('year', '==', year)
    ];
  
    if (month !== '-') {
      queryConstraints.push(where('month', '==', month));
    }
    if (supplier !== '-') {
      queryConstraints.push(where('companyname', '==', supplier));
    }
  
    onSnapshot(
      query(
        collection(this.db, "orders"),
        ...queryConstraints
      ),
      docs => handler(docs)
    );
  }

  async getOrderDetails({ id, handler }) {
    onSnapshot(
      query(
        doc(this.db, 'orders', id)
      ),
      docs => handler(docs)
    )
  }

  async updateOrderField({ orderId, field, value, lastEdit, lastEditBy }) {
    if (!orderId || !field) {
      console.error("Invalid update request: Missing settingId or field.");
      return;
    }
  
    try {
      const orderRef = doc(this.db, "orders", orderId);
  
        await updateDoc(orderRef, {
          [field]: value,
          lastEdit,
          lastEditBy,
        });
        console.log(`Updated ${field} for order ${orderId}`);
      
    } catch (error) {
      console.error("Update failed:", error);
    }
  }

  async updateOrderDate({orderId, date, year, month, lastEdit, lastEditBy }){
    const data = {
        date,
        year,
        month,
        lastEdit,
        lastEditBy,

    };
    const orderRef = doc(this.db, 'orders', orderId)
    await setDoc(
      orderRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated order");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  async updateOrderPosition({orderId, orderItems, lastEdit, lastEditBy}){
    //Grab through reference all comments Array in firestore
    let actualPosition = orderItems

    let orderRef = doc(this.db, "orders", orderId)

    await updateDoc(orderRef, {
      items: actualPosition,
      lastEdit: lastEdit,
      lastEditBy: lastEditBy,
    })
  }

  async appendOrderPositions({orderId, items, lastEdit, lastEditBy}){
    // console.log(items)
    const data = {
        "amount": items[0].amount,
        "articlenr": items[0].articlenr,
        "description": items[0].description,
        "itemtitle": items[0].itemtitle,
        "price": items[0].price,
        "taxpercentage": items[0].taxpercentage,
        // "total": items[0].total,
        "unit": items[0].unit,
        "stockmanagement": items[0].stockmanagement,
        "stock": items[0].stock,
        "id": items[0].id
    };

    let orderRef = doc(this.db, "orders", orderId)

    await updateDoc(orderRef, {
      items: arrayUnion(data),
      lastEdit: lastEdit,
      lastEditBy: lastEditBy,
    })
  }

  async deleteOrderPosition({orderId, item}){
    let orderRef = doc(this.db, "orders", orderId)
    await updateDoc(orderRef , {
     items: arrayRemove(item)
    })
    .catch(function(error) {
      console.error("Error removing document: ", error);
    });
  }

  async updateOrderCancellation({orderId, cancelled, lastEdit, lastEditBy}){
    const data = {
        cancelled,
        lastEdit,
        lastEditBy
    };
    const orderRef = doc(this.db, 'orders', orderId)
    await setDoc(
      orderRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated order");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  async updateOrderDelivered({orderId, delivered, deliveryDate, note, lastEdit, lastEditBy}){
    const data = {
        delivered,
        deliveryDate,
        note,
        lastEdit,
        lastEditBy
    };
    const orderRef = doc(this.db, 'orders', orderId)
    await setDoc(
      orderRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated order");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  async getOpenOrdersByOrganization ({ organizationId, handler }) {
    const ordersCol = collection(this.db, 'orders')
    const ordersQuery = query(
      ordersCol,
        where('organizationId', '==', organizationId),
        where('delivered', '==', false),
        where('cancelled', '==', false)
      )

      const snapshot = await getCountFromServer(ordersQuery)

      return handler(snapshot.data().count)
  }

  async getOpenOrdersByUser ({ userId, handler }) {
    const ordersCol = collection(this.db, 'orders')
    const ordersQuery = query(
      ordersCol,
        where('uid', '==', userId),
        where('delivered', '==', false),
        where('cancelled', '==', false)
      )

      const snapshot = await getCountFromServer(ordersQuery)

      return handler(snapshot.data().count)
  }

  async updateOrderSendt({orderId, orderSendt, orderSendtDate, lastEdit, lastEditBy}){
    const data = {
        orderSendt,
        orderSendtDate,
        lastEdit,
        lastEditBy
    };
    const orderRef = doc(this.db, 'orders', orderId)
    await setDoc(
      orderRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated order");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  getLatestOrderNo ({ organizationId, handler }) {
    onSnapshot(
      query(
        collection(this.db, "orders"),
        where('organizationId', '==', organizationId),
        orderBy('dataCreated', 'desc'),
        limit(3) // die letzten 3 weil wenn eine nicht vorhanden ist damit die lezte gültige genommen werden kann
      ),
      docs => handler(docs)
    )
  }

  async updateRecurringOrderMode({ orderId, recurringOrder, remainingOccurrences, nextRecurringDate, lastEdit, lastEditBy }) {
    console.log('Next Recurring Date: ' + nextRecurringDate)
    // Normalisiere `remainingOccurrences`
    const normalizedRemainingOccurrences = typeof remainingOccurrences === 'number'
        ? remainingOccurrences
        : parseFloat(remainingOccurrences) || -1;

    const data = {
        recurringOrder,
        remainingOccurrences: normalizedRemainingOccurrences,
        lastEdit,
        lastEditBy,
    };

    // Bestellung von `nextRecurringDate`, falls es nicht übergeben wurde
    if (recurringOrder) {
        // Wenn `nextRecurringDate` übergeben wird, setze es
        if (nextRecurringDate) {
            data.nextRecurringDate = nextRecurringDate;
        }
        // Standardwert für `recurringInterval` setzen, falls es nicht gesetzt wurde
        if (!data.recurringInterval) {
          data.recurringInterval = 'yearly'; // Standardwert für Intervall setzen
        }
    } else {
        // Setze Felder zurück, wenn wiederkehrend deaktiviert wird
        data.remainingOccurrences = deleteField();
        data.nextRecurringDate = deleteField();
        data.recurringInterval = deleteField();
    }

    const orderRef = doc(this.db, 'orders', orderId);

    try {
        // Speichern der Daten in der Datenbank
        await setDoc(orderRef, data, { merge: true });
        console.log('Updated order in database:', data);
    } catch (error) {
        console.error('Error updating order:', error);
    }
  }

  async updateRecurringOrderInterval({orderId, recurringInterval, nextRecurringDate, lastEdit, lastEditBy}){
    const data = {
        recurringInterval,
        nextRecurringDate,
        lastEdit,
        lastEditBy
    };
    const orderRef = doc(this.db, 'orders', orderId)
    await setDoc(
      orderRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated order");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  async updateRemainingOrderOccurrences({orderId, remainingOccurrences, lastEdit, lastEditBy}){
    const data = {
        // remainingOccurrences,
        // remainingOccurrences: typeof remainingOccurrences === 'number' ? remainingOccurrences : parseFloat(remainingOccurrences), // Ensure number type
        remainingOccurrences: typeof remainingOccurrences === 'number'
          ? remainingOccurrences
          : parseFloat(remainingOccurrences) || -1,
        lastEdit,
        lastEditBy
    };
    const orderRef = doc(this.db, 'orders', orderId)
    await setDoc(
      orderRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated order");
    })
    .catch((error) => {
      console.error(error);
    });
  }
  /********************************
  ORDERS END
  ********************************/

  /********************************
  ARTICLES START
  ********************************/
  // GET ALL Articles WITH LIVE UPDATE FOR CSV EXPORT
  getAllArticles ({ organizationId, handler}) {
    onSnapshot(
      query(
        collection(this.db, "articles"),
        // where('user', '==', user),
        where('organizationId', '==', organizationId),
      ),
      docs => handler(docs)
    )
  }

  // GET ARTICLES WITH LIVE UPDATE
  getLiveArticles ({ organizationId, handler }) {
    onSnapshot(
      query(
        collection(this.db, "articles"),
        // where("user", "==", user),
        where('organizationId', '==', organizationId),
      ),
      docs => handler(docs)
    )
  }

  // async getProducts({ organizationId }) {
  //   // var lastItem = null
  //   const ref = query(collection(this.db, 'articles'),
  //     // where('user', '==', user),
  //     where('organizationId', '==', organizationId),
      
  //   )

  //   const data = await getDocs(ref)
  //   return data 
  // }

  // GET LATEST ARTICLES WITH LIVE UPDATE
  getLatestArticles ({ organizationId, handler }) {
    onSnapshot(
      query(
        collection(this.db, "articles"),
        // where('user', '==', user),
        where('organizationId', '==', organizationId),
        orderBy('dataCreated', 'desc'),
        limit(3)
      ),
      docs => handler(docs)
    )
  }


  // async getSingleArticle({ articleId, handler }) {
  //   onSnapshot(
  //     query(
  //       doc(this.db, 'articles', articleId)
  //     ),
  //     docs => handler(docs)
  //   )    
  // }

  async getSingleArticle({ articleId }) {
    const docRef = doc(this.db, "articles", articleId);
    const docSnap = await getDoc(docRef);

    // if (docSnap.exists()) {
    //   console.log("Document data:", docSnap.data());
    // } else {
    //   console.log("No document found!");
    // }

    return docSnap
  }

  async getArticles({ organizationId, resetCursor = false }) {
    const cursorKey = `articles:${organizationId}`
    if (resetCursor) {
      delete this.paginationCursors[cursorKey]
    }
    const cursor = this.paginationCursors[cursorKey]
    const constraints = [
      where('organizationId', '==', organizationId),
      orderBy('dataCreated'),
    ]

    if (cursor) {
      constraints.push(startAfter(cursor))
    }

    constraints.push(limit(2))

    const ref = query(
      collection(this.db, 'articles'),
      ...constraints
    )

      const data = await getDocs(ref)

      if (!data.empty) {
        this.paginationCursors[cursorKey] = data.docs[data.docs.length - 1]
      }

      return data
  }
  /********************************
  ARTICLES END
  ********************************/


  /********************************
  ACCOUNTING
  ********************************/

  // getOverviewInvoices ({ user, onSnapshot, year }) {
  //   return this.db.collection('invoices')
  //     .where('user', '==', user)
  //     .where('year', '==', year)
  //     // .orderBy('dataCreated', 'desc')
  //     .onSnapshot(onSnapshot)
  // }

  // GET EARNINGS WITH LIVE UPDATE
  // getEarnings ({ organizationId, year, month, customer, handler }) {
  //   if (customer === '-' && month !== '-'){
  //     onSnapshot(
  //       query(
  //         collection(this.db, "invoices"),
  //         // where("user", "==", user),
  //         where('organizationId', '==', organizationId),
  //         where('year', '==', year),
  //         where('month', '==', month)
  //       ),
  //       docs => handler(docs)
  //     )
  //   }

  //   if(customer !== '-' && month !== '-'){
  //     onSnapshot(
  //       query(
  //         collection(this.db, "invoices"),
  //         // where('user', '==', user),
  //         where('organizationId', '==', organizationId),
  //         where('year', '==', year),
  //         where('month', '==', month),
  //         where('companyname', '==', customer)
  //       ),
  //       docs => handler(docs)
  //     )
  //   }

  //   if(customer === '-' && month === '-'){
  //     onSnapshot(
  //       query(
  //         collection(this.db, "invoices"),
  //         // where('user', '==', user),
  //         where('organizationId', '==', organizationId),
  //         where('year', '==', year)
  //       ),
  //       docs => handler(docs)
  //     )
  //   }

  //   else if(month === '-'){
  //     onSnapshot(
  //       query(
  //         collection(this.db, "invoices"),
  //         // where('user', '==', user),
  //         where('organizationId', '==', organizationId),
  //         where('year', '==', year),
  //         where('companyname', '==', customer)
  //       ),
  //       docs => handler(docs)
  //     )
  //   }
  // }

  /********************************
  EXPENSES START
  ********************************/
  // GET LATEST EXPENSES WITH LIVE UPDATE
  getLatestOrganizationExpenses ({ organizationId, handler }) {
    onSnapshot(
      query(
        collection(this.db, "expenses"),
        where("organizationId", "==", organizationId),
        orderBy('dataCreated', 'desc'),
        limit(3)
      ),
      docs => handler(docs)
    )
  }

  getLatestExpenses ({ userId, handler }) {
    onSnapshot(
      query(
        collection(this.db, "expenses"),
        where("uid", "==", userId),
        orderBy('dataCreated', 'desc'),
        limit(3)
      ),
      docs => handler(docs)
    )
  }

  getExpensesByOrganization({ organizationId, year, month, category, teammember, handler }) {
    const queryConstraints = [
      where('organizationId', '==', organizationId),
      where('year', '==', year)
    ];
  
    if (month !== '-') {
      queryConstraints.push(where('month', '==', month));
    }
    if (category !== '-') {
      queryConstraints.push(where('category', '==', category));
    }
    if (teammember !== '-') {
      queryConstraints.push(where('uid', '==', teammember));
    }
  
    onSnapshot(
      query(
        collection(this.db, "expenses"),
        ...queryConstraints
      ),
      docs => handler(docs)
    );
  }
  

  getExpenses({ userId, year, month, category, handler }) {
    const queryConstraints = [
      where('uid', '==', userId),
      where('year', '==', year)
    ];
  
    if (month !== '-') {
      queryConstraints.push(where('month', '==', month));
    }
    if (category !== '-') {
      queryConstraints.push(where('category', '==', category));
    }
  
    onSnapshot(
      query(
        collection(this.db, "expenses"),
        ...queryConstraints
      ),
      docs => handler(docs)
    );
  }
  

  // // GET EXPENSES WITH LIVE UPDATE
  // getExpensesByYear ({ user, onSnapshot, year }) {
  //   return this.db.collection('expenses')
  //     .where('user', '==', user)
  //     .where('year', '==', year)
  //     // .orderBy('dataCreated', 'desc')
  //     .onSnapshot(onSnapshot)
  // }

  // // GET OVERVIEW EXPENSES WITH LIVE UPDATE
  // getOverviewExpenses ({ user, onSnapshot, year }) {
  //   return this.db.collection('expenses')
  //     .where('user', '==', user)
  //     .where('year', '==', year)
  //     // .orderBy('dataCreated', 'desc')
  //     .onSnapshot(onSnapshot)
  // }
  // For Notification length

  async getAllNotifications({ handler }) {
    const q = query(collection(this.db, "notifications"));
    onSnapshot(q, (snapshot) => {
      const notifications = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      handler(notifications);
    });
  };

  async getUnpayedExpensesByOrganization({ organizationId, handler }) {
    const expensesCol = collection(this.db, 'expenses')
    const expensesQuery = query(
      expensesCol,
        where('organizationId', '==', organizationId),
        where('payed', '==', false)
      )

      const snapshot = await getCountFromServer(expensesQuery)
      
      return handler(snapshot.data().count)
  }

  async getUnpayedExpensesByUser({ userId, handler }) {
    const expensesCol = collection(this.db, 'expenses')
    const expensesQuery = query(
      expensesCol,
        where('uid', '==', userId),
        where('payed', '==', false)
      )

      const snapshot = await getCountFromServer(expensesQuery)
      
      return handler(snapshot.data().count)
  }



async getDueUnpayedExpensesByOrganization({ organizationId, handler }) {
  const todayTimestamp = getTodayTimestamp();

  const expensesCol = collection(this.db, "expenses");
  const expensesQuery = query(
    expensesCol,
    where("organizationId", "==", organizationId),
    where("payed", "==", false),
    where("dueDate", "<=", todayTimestamp) // Hier filtern wir nach Fälligkeit
  );

  const snapshot = await getCountFromServer(expensesQuery);

  return handler(snapshot.data().count);
}

async getDueUnpayedExpensesByUser({ userId, handler }) {
  const todayTimestamp = getTodayTimestamp();

  const expensesCol = collection(this.db, "expenses");
  const expensesQuery = query(
    expensesCol,
    where("uid", "==", userId),
    where("payed", "==", false),
    where("dueDate", "<=", todayTimestamp) // Hier filtern wir nach Fälligkeit
  );

  const snapshot = await getCountFromServer(expensesQuery);

  return handler(snapshot.data().count);
}

  /********************************
  EXPENSES END
  ********************************/

  async deleteTodo({todoId}){
    let todoRef = doc(this.db, "todos", todoId)

    await deleteDoc(todoRef)
    .then(() => {
      // console.log("Todo deleted")
    })
    .catch((error) => {
      console.error(error);
    })

    // let todoRef = this.db.collection('todos')
    // .doc(todoId)
    // todoRef.delete()
  }

  async deleteNote({noteId}){
    const noteRef = doc(this.db, 'notes', noteId)
    
    await deleteDoc(noteRef)
    .then(() => {
      console.log("Note deleted")
    })
    .catch((error) => {
      console.error(error);
    })
  }

  // async deleteCalendarEntry({calendarentryId}){
  //   const calendarEntryRef = doc(this.db, 'calendarentries', calendarentryId)

  //   await deleteDoc(calendarEntryRef)
  //   .then(() => {
  //     console.log("Calendar entry deleted")
  //   })
  //   .catch((error) => {
  //     console.error(error);
  //   })
  // }

  async deleteCalendarEntry({ calendarentryId }) {
    if (!calendarentryId) {
      console.error("Missing calendarentryId. Deletion aborted.");
      return { success: false, error: "Invalid parameter: calendarentryId is required." };
    }
  
    const calendarEntryRef = doc(this.db, 'calendarentries', calendarentryId);
  
    try {
      await deleteDoc(calendarEntryRef);
      console.log(`Calendar entry ${calendarentryId} successfully deleted`);
      return { success: true };
    } catch (error) {
      if (error.code === 'permission-denied') {
        console.error(`Permission denied for deleting calendar entry ${calendarentryId}:`, error);
        return { success: false, error: "Permission denied" };
      } else {
        console.error(`Error deleting calendar entry ${calendarentryId}:`, error);
        return { success: false, error };
      }
    }
  }

  async deleteCustomer({customerId}){
    const customerRef = doc(this.db, 'customers', customerId)

    await deleteDoc(customerRef)
    .then(() => {
      console.log("Customer deleted")
    })
    .catch((error) => {
      console.error(error);
    })
  }

  async deleteArticle({articleId}){
    const articleRef = doc(this.db, 'articles', articleId)

    await deleteDoc(articleRef)
    .then(() => {
      console.log("Article deleted")
    })
    .catch((error) => {
      console.error(error);
    })
  }

//   async deleteArticleInventoryLog({ articleId }) {
//     const articleRef = doc(this.db, 'articles', articleId);
//     console.log(articleId)
//     try {
//         // Setzt das `inventorylog`-Feld auf ein leeres Array
//         await updateDoc(articleRef, {
//             inventorylog: []
//         });
//         console.log("Inventory log successfully cleared");
//     } catch (error) {
//         console.error("Error clearing inventory log:", error);
//         throw error; // Fehler für die obere Ebene propagieren
//     }
// }

async deleteArticleInventoryLog({ articleId }) {
  console.log(articleId)
  console.log("Deleting inventory log for articleId:", articleId);

  const articleRef = doc(this.db, "articles", articleId);

  try {
      await updateDoc(articleRef, {
          inventorylog: deleteField(),
      });
      console.log(`Inventory log for article ${articleId} deleted`);
  } catch (error) {
      console.error("Error deleting inventory log:", error);
      throw error;
  }
}


  async deleteInvoice({invoiceId}){
    const invoiceRef = doc(this.db, "invoices", invoiceId)

    return new Promise( (resolve, reject) => {
      resolve(deleteDoc(invoiceRef))
         .then((response) => console.log(response))
      })
  }

  async deleteOrder({orderId}){
    const orderRef = doc(this.db, "orders", orderId)

    return new Promise( (resolve, reject) => {
      resolve(deleteDoc(orderRef))
         .then((response) => console.log(response))
      })
  }

  async deleteOffer({offerId}){
    const offerRef = doc(this.db, "offers", offerId)
    await deleteDoc(offerRef)
    .then(() => {
      console.log("Offer deleted")
    })
    .catch((error) => {
      console.error(error);
    })
  }

  // async deleteInvoicePosition({invoiceId, item}){
  //   let invoiceRef = this.db.collection('invoices')
  //   .doc(invoiceId)
  //   invoiceRef.update({
  //    items: firebase.firestore.FieldValue.arrayRemove(item)
  //   })
  //   .catch(function(error) {
  //     console.error("Error removing document: ", error);
  //   });
  // }

  async deleteInvoicePosition({invoiceId, item}){
    // let invoiceRef = collection(this.db, 'invoices')
    // doc(invoiceId)
    let invoiceRef = doc(this.db, "invoices", invoiceId)
    await updateDoc(invoiceRef , {
     items: arrayRemove(item)
    })
    .catch(function(error) {
      console.error("Error removing document: ", error);
    });
  }

  async deleteOfferPosition({offerId, item}){
    // let offerRef = this.db.collection('offers')
    // .doc(offerId)
    let offerRef = doc(this.db, "offers", offerId)
    await updateDoc(offerRef , {
     items: arrayRemove(item)
    })
    .catch(function(error) {
      console.error("Error removing document: ", error);
    });
  }


//   // Get a new write batch
// var batch = db.batch();
//
// // Set the value of 'NYC'
// var nycRef = db.collection("cities").doc("NYC");
// batch.set(nycRef, {name: "New York City"});
//
// var invoiceRef = this.db.collection('invoices')
// .doc(invoiceId)
// // Update the population of 'SF'
// var sfRef = db.collection("cities").doc(invoiceId);
// batch.update(invoiceRef, {"population": 1000000});
//
// // Delete the city 'LA'
// var laRef = db.collection("cities").doc("LA");
// batch.delete(laRef);
//
// // Commit the batch
// batch.commit().then(function () {
//     // ...
// });




  // });
  // }

  // fb.usersCollection.doc(docId).update({
  //    posts: posts.filter(post => post.id !== deleteId);
  //  })

  // docRef.update({
  //  array: FieldValue.arrayRemove('idToRemove');
  // });

  // async deleteEarning({earningId}){
  //   let earningRef = this.db.collection('invoices')
  //   .doc(earningId)
  //   earningRef.delete()
  // }

  async deleteEarning({earningId}){
    let earningRef = doc(this.db, "invoices", earningId)
    await deleteDoc(earningRef)
      .then(() => {
        console.log("Earning deleted")
      })
      .catch((error) => {
        console.error(error);
      })
  }

  async deleteExpense({expenseId}){
    let expenseRef = doc(this.db, "expenses", expenseId)
    await deleteDoc(expenseRef)
      .then(() => {
        console.log("Expense deleted")
      })
      .catch((error) => {
        console.error(error);
      })
  }



  /***************************
  START SETTINGS UPDATES
  ***************************/

  async updateSettingField({ settingId, field, value, lastEdit, lastEditBy }) {
    if (!settingId || !field) {
      console.error("Invalid update request: Missing settingId or field.");
      return;
    }
  
    try {
      const settingRef = doc(this.db, "settings", settingId);
  
        await updateDoc(settingRef, {
          [field]: value,
          // lastEdit,
          // lastEditBy,
        });
        console.log(`Updated ${field} for setting ${settingId}`);
      
    } catch (error) {
      console.error("Update failed:", error);
    }
  }


  // async updateLogo({settingId, logo}){
  //   const data = {
  //       logo,
  //   };
  //   const settingsRef = doc(this.db, 'settings', settingId)

  //   return new Promise( (resolve, reject) => {
  //     // const resolver = resolve(settingsRef.set(data, { merge: true }))
  //     const resolver = resolve(setDoc(settingsRef, data, {merge: true}))

  //     resolver.then((response) => console.log(response))
  //   })
  // }

  async updateLogo({ settingId, logo }) {
    const data = { logo };
    const settingsRef = doc(this.db, 'settings', settingId);
  
    return setDoc(settingsRef, data, { merge: true })
      .then(() => {
        // console.log('Logo updated successfully:', response);
        return 'Logo updated successfully';
      })
      .catch((error) => {
        console.error('Error updating logo:', error);
        throw error;
      });
  }

  async updateMenuFavorites({ settingId, userId, menuFavorites }) {
    if (!settingId || !userId) {
      console.error("Missing settingId or userId:", { settingId, userId });
      return;
    }
  
    const settingsRef = doc(this.db, 'settings', settingId);
  
    try {
      // Menü-Favoriten direkt unter `menuFavorites` des Benutzers speichern
      const updatedFavorites = {
        menuFavorites: {
          [userId]: menuFavorites, // Benutzer-ID als Schlüssel
        },
      };
  
      await setDoc(settingsRef, updatedFavorites, { merge: true });
      console.log(`Favorites updated for user ${userId}`);
    } catch (error) {
      console.error("Error updating menuFavorites:", error);
    }
  }

  async updateMenuOrder({ settingId, userId, menuOrder }) {
    if (!settingId || !userId) {
      console.error("Missing settingId or userId:", { settingId, userId });
      return;
    }

    const settingsRef = doc(this.db, 'settings', settingId);

    try {
      await setDoc(settingsRef, {
        menuOrder: {
          [userId]: menuOrder,
        },
      }, { merge: true });
      console.log(`Menu order updated for user ${userId}`);
    } catch (error) {
      console.error("Error updating menuOrder:", error);
    }
  }

  async updateSettingsAiLock ({settingId, aiClickHistory, aiLockTime = 0}) {
    const data = {
      aiClickHistory,
      aiLockTime
    };
    const settingsRef = doc(this.db, 'settings', settingId); // Korrekte Methode zum Abrufen des Dokuments
  
    try {
      // `merge: true` stellt sicher, dass nur die angegebenen Felder aktualisiert werden
      await setDoc(
        settingsRef, data,
        { merge: true });
        console.log("AI settings updated");
    } catch (error) {
      console.error("Error updating AI settings:", error);
    }
  }


  async updateCopilotUsage({
    settingId,
    copilotUsage
  }) {
    const data = {
      copilotUsage
    }

    const settingsRef = doc(
      this.db,
      'settings',
      settingId
    )

    try {
      await setDoc(
        settingsRef,
        data,
        { merge: true }
      )

      console.log(
        'Copilot usage updated:',
        settingId,
        copilotUsage
      )
    } catch (error) {
      console.error(
        'Error updating Copilot usage:',
        error
      )

      throw error
    }
  }

  /***************************
  END START SETTINGS UPDATES
  ***************************/


  /*********************
  START TODO
  **********************/
  createTodo({ organizationId, title, username, scheduled, scheduledTime, date, time }){
    const createTodoCallable = httpsCallable(this.functions, 'createTodo')

    return new Promise((resolve) => {  
      resolve(createTodoCallable({
        organizationId,
        title,
        username,
        scheduled,
        scheduledTime,
        date,
        time
      }))
    })
  }

  async updateTodoTitle({todoId, title, lastEdit, lastEditBy}){
    const data = {
        title,
        lastEdit,
        lastEditBy
    };
    const todoRef = doc(this.db, 'todos', todoId)

    await setDoc(
      todoRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated todo");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  async updateTodoScheduled({todoId, scheduled, date, lastEdit, lastEditBy}){
    const data = {
        scheduled,
        date,
        lastEdit,
        lastEditBy
    };
    const todoRef = doc(this.db, 'todos', todoId)
    await setDoc(
      todoRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated todo");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  async updateTodoScheduledTime({todoId, scheduledTime, time, lastEdit, lastEditBy}){
    const data = {
        scheduledTime,
        time,
        lastEdit,
        lastEditBy
    };
    const todoRef = doc(this.db, 'todos', todoId)
    await setDoc(
      todoRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated todo");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  async updateTodoDate({todoId, date, lastEdit, lastEditBy}){
    const data = {
        date,
        lastEdit,
        lastEditBy
    };
    const todoRef = doc(this.db, 'todos', todoId)

    await setDoc(
      todoRef, data,
      {merge: true }
    ).then(() => {
      console.log("Updated todo");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  async updateTodoTime({todoId, time, lastEdit, lastEditBy}){
    const data = {
      time,
      lastEdit,
      lastEditBy
    };
    const todoRef = doc(this.db, 'todos', todoId)

    await setDoc(
      todoRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated todo time");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  async updateTodoCheckbox({todoId, completed, lastEdit, lastEditBy}){
    const data = {
        completed,
        lastEdit,
        lastEditBy
    };
    const todoRef = doc(this.db, 'todos', todoId)

    await setDoc(
      todoRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated todo");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  getTodaysUpcomingTodosByUser ({ userId, handler }) {
    const startOfDay = new Date()
    startOfDay.setHours(0, 0, 0, 0)
    const endOfDay = new Date()
    endOfDay.setHours(23, 59, 59, 999)
    const parseTodoDate = value => {
      if (!value) return null
      if (value instanceof Date) return value
      if (typeof value?.toDate === 'function') return value.toDate()

      const parsedDate = new Date(value)
      return Number.isNaN(parsedDate.getTime()) ? null : parsedDate
    }

    return onSnapshot(
      query(
        collection(this.db, 'todos'),
        where('uid', '==', userId),
        where('completed', '==', false)
      ),
      docs => {
        const count = docs.docs.filter(doc => {
          const todo = doc.data()
          const isScheduled = todo.scheduled === true || todo.scheduled === 'true'

          if (!isScheduled) {
            return false
          }

          const todoDate = parseTodoDate(todo.date)
          if (!todoDate) {
            return false
          }

          return todoDate >= startOfDay && todoDate <= endOfDay
        }).length

        handler(count)
      },
      error => {
        console.error('Error fetching todays todos:', error)
        handler(0)
      }
    )
  }

  async updateTodoPinState(todoId, isPinned, lastEdit, lastEditBy) {
    
    try {
      const data = {
        isPinned,
        lastEdit,
        lastEditBy
      }
      const todoRef = doc(this.db, 'todos', todoId);
      
      await setDoc(
        todoRef, data, { merge: true });
      console.log('Todo updated');
    } catch (error) {
      console.error('Error updating pin status: ', error);
    }
  }

  async updateTodoPriority({ todoId, priority, lastEdit, lastEditBy }) {
    try {
      const data = {
        priority,
        lastEdit,
        lastEditBy
      };
  
      const todoRef = doc(this.db, 'todos', todoId);
      
      await setDoc(
        todoRef, 
        data, 
        { merge: true }  // Merged das Update mit den bestehenden Feldern im Dokument
      );
      console.log('Todo updated');
    } catch (error) {
      console.error('Error updating priority: ', error);
    }
  }


  /*********************
  END TODO
  **********************/


  // CALENDAR START
  async updateCalendarEntryTitle({calendarEntryId, title, lastEdit, lastEditBy}){
    const data = {
        title,
        lastEdit,
        lastEditBy
    };
    const calendarEntryRef = doc(this.db, 'calendarentries', calendarEntryId)

    await setDoc(
      calendarEntryRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated calendar entry");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  async updateCalendarFullDayEvent({calendarEntryId, allDay, lastEdit, lastEditBy}){
    const data = {
        allDay,
        lastEdit,
        lastEditBy
    };
    const calendarEntryRef = doc(this.db, 'calendarentries', calendarEntryId)
    await setDoc(
      calendarEntryRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated todo");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  async updateCalendarEntryStarttime({calendarEntryId, start, lastEdit, lastEditBy}){
    const data = {
        start,
        lastEdit,
        lastEditBy
    };
    const calendarEntryRef = doc(this.db, 'calendarentries', calendarEntryId)

    await setDoc(
      calendarEntryRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated calendar entry");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  async updateCalendarEntryEndtime({calendarEntryId, end, lastEdit, lastEditBy}){
    const data = {
        end,
        lastEdit,
        lastEditBy
    };
    const calendarEntryRef = doc(this.db, 'calendarentries', calendarEntryId)

    await setDoc(
      calendarEntryRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated calendar entry");
    })
    .catch((error) => {
      console.error(error);
    });
  }


  async updateCalendarEntryInDB (id, updates, editBy) {
    const calendarEntryRef = doc(this.db, 'calendarentries', id);
  
    updates.lastEdit = new Date();
    updates.lastEditBy = editBy; // Annahme: currentUserId ist verfügbar
  
    await setDoc(calendarEntryRef, updates, { merge: true })
      .then(() => console.log(`Eintrag ${id} erfolgreich aktualisiert`))
      .catch(console.error);
  };
  

  

  async updateCalendarEntryLocation({calendarEntryId, location, lastEdit, lastEditBy}){
    const data = {
        location,
        lastEdit,
        lastEditBy
    };
    const calendarEntryRef = doc(this.db, 'calendarentries', calendarEntryId)

    await setDoc(
      calendarEntryRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated calendar entry");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  async updateCalendarEntryDescription({calendarEntryId, description, lastEdit, lastEditBy}){
    const data = {
        description,
        lastEdit,
        lastEditBy
    };
    const calendarEntryRef = doc(this.db, 'calendarentries', calendarEntryId)

    await setDoc(
      calendarEntryRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated calendar entry");
    })
    .catch((error) => {
      console.error(error);
    });
  }
  // CALENDAR END

  /*****************************
  CUSTOMER START
  *****************************/

  async updateCustomerField({ customerId, field, value, lastEdit, lastEditBy }) {
    if (!customerId || !field) {
      console.error("Invalid update request: Missing customerId or field.");
      return;
    }
  
    try {
      const customerRef = doc(this.db, "customers", customerId);
  
      // Falls das zu aktualisierende Feld Teil eines Arrays ist
      if (field.startsWith("contactPersons.")) {
        // Extrahiere den Index aus dem Feldnamen (z.B. contactPersons.0.academictitlebefore)
        const match = field.match(/^contactPersons\.(\d+)\.(.+)$/);
        if (!match) {
          console.error("Invalid field format for array update.");
          return;
        }
  
        const index = parseInt(match[1], 10); // Index des Arrays
        const subField = match[2]; // Das eigentliche Feld, das aktualisiert werden soll
  
        // Lade den aktuellen Lieferanten aus der Datenbank
        const customerDoc = await getDoc(customerRef);
        if (!customerDoc.exists()) {
          console.error("Customer not found");
          return;
        }
  
        const customerData = customerDoc.data();
  
        // Prüfe, ob `contactPersons` existiert und der Index gültig ist
        if (!customerData.contactPersons || !customerData.contactPersons[index]) {
          console.error("Invalid contact person index");
          return;
        }
  
        // Erstelle eine Kopie des Arrays und aktualisiere das gewünschte Feld
        const updatedContactPersons = [...customerData.contactPersons];
        updatedContactPersons[index] = {
          ...updatedContactPersons[index],
          [subField]: value,
        };
  
        // Update in Firestore
        await updateDoc(customerRef, {
          contactPersons: updatedContactPersons,
          lastEdit,
          lastEditBy,
        });
  
        console.log(`Updated ${field} for customer ${customerId}`);
      } else {
        // Falls das Feld kein Array ist, normal aktualisieren
        await updateDoc(customerRef, {
          [field]: value,
          lastEdit,
          lastEditBy,
        });
        console.log(`Updated ${field} for customer ${customerId}`);
      }
    } catch (error) {
      console.error("Update failed:", error);
    }
  }


  async updateCustomerActiveState({customerId, active, lastEdit, lastEditBy}){
    const data = {
        active,
        lastEdit,
        lastEditBy
    };
    const customerRef = doc(this.db, 'customers', customerId)

    await setDoc(
      customerRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated customer");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  async appendCustomerContactPerson({customerId, newContactPerson, lastEdit, lastEditBy}){
    // console.log(newContactPerson)
    // console.log(newContactPerson.academictitlebefore)
    const data = {
        "academictitlebefore": newContactPerson.academictitlebefore,
        "academictitleafter": newContactPerson.academictitleafter,
        "firstname": newContactPerson.firstname,
        "secondname": newContactPerson.secondname,
        "email": newContactPerson.email,
        "tel": newContactPerson.tel,
        "note": newContactPerson.note,
    };

    let customerRef = doc(this.db, "customers", customerId)

    await updateDoc(customerRef, {
      contactPersons: arrayUnion(data),
      lastEdit: lastEdit,
      lastEditBy: lastEditBy,
    })
  }

  async deleteContactPerson({ customerId, person }) {
    let customerRef = doc(this.db, "customers", customerId);
    
    try {
      await updateDoc(customerRef, {
        contactPersons: arrayRemove(person)
      });
      console.log('Contact person succesfully deleted');
    } catch (error) {
      console.error("Delete failed: ", error);
      throw error;
    }
  }

  /*****************************
  CUSTOMER END
  *****************************/


  /*****************************
  ARTICLE START
  *****************************/

  async updateArticleField({ articleId, field, value, lastEdit, lastEditBy }) {
    if (!articleId || !field) {
      console.error("Invalid update request: Missing articleId or field.");
      return;
    }
  
    try {
      const articleRef = doc(this.db, "articles", articleId);
  
        await updateDoc(articleRef, {
          [field]: value,
          lastEdit,
          lastEditBy,
        });
        console.log(`Updated ${field} for article ${articleId}`);
      
    } catch (error) {
      console.error("Update failed:", error);
    }
  }


  async updateArticleAmount({articleId, amount, lastEdit, lastEditBy}){
    const data = {
        amount,
        lastEdit,
        lastEditBy
    };
    const articleRef = doc(this.db, 'articles', articleId)
    await setDoc(
      articleRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated article");
    })
    .catch((error) => {
      console.error(error);
    });
  }


  async updateArticlePrice({articleId, price, lastEdit, lastEditBy}){
    const data = {
        price,
        lastEdit,
        lastEditBy
    };
    const articleRef = doc(this.db, 'articles', articleId)
    await setDoc(
      articleRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated article");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  async createArticleStockMovement({articleId, move, note, stock, lastEdit, lastEditBy}){
    const data = {
        "date": new Date().toISOString(),
        "stock": Number(stock),
        "user": lastEditBy,
        "note": note,
        // "move": stock > oldStockValue ? ( + (stock - oldStockValue)) : ( - (oldStockValue - stock))
        "move": move

    };
    let articleRef = doc(this.db, "articles", articleId)
    // articleRef.set(data, { merge: true });
    await updateDoc(articleRef, {
      inventorylog: arrayUnion(data),
      stock: Number(stock),
      lastEdit: lastEdit,
      lastEditBy: lastEditBy,
    })
  }

  async updateDeletedInvoiceStockPosition({articleId, inventorylog, note, stock, deletedAmount, lastEdit, lastEditBy}){
    // const diff = currentArticlePosAmount - newArticlePosAmount

    const data = {
        "date": new Date().toISOString(),
        "stock": stock,
        "user": lastEditBy,
        "note": note,
        "move": deletedAmount


    };
    
    let articleRef = doc(this.db, "articles", articleId)
    // articleRef.set(data, { merge: true });
    await updateDoc(articleRef, {
      inventorylog: arrayUnion(data),
      stock: stock,
      lastEdit: lastEdit,
      lastEditBy: lastEditBy,
    })
  }

  async updateArticleStockInvoicePosition({articleId, inventorylog, note, stock, currentArticlePosAmount, newArticlePosAmount, lastEdit, lastEditBy}){
    // const diff = currentArticlePosAmount - newArticlePosAmount

    const data = {
        // stock,
        // "inventorylog": inventorylog[0].inventorylog,
        "date": new Date().toISOString(),
        "stock": stock,
        "user": lastEditBy,
        "note": note,
        // "move": newArticlePosAmount > currentArticlePosAmount ? ( + (newArticlePosAmount - currentArticlePosAmount)) : ( - (currentArticlePosAmount - newArticlePosAmount))
        // "move": newArticlePosAmount > currentArticlePosAmount ? ( - (newArticlePosAmount - currentArticlePosAmount)) : ( + (newArticlePosAmount - currentArticlePosAmount - ))
        "move": currentArticlePosAmount - newArticlePosAmount
        // "move": "3"

    };

    let articleRef = doc(this.db, "articles", articleId)
    // articleRef.set(data, { merge: true });
    await updateDoc(articleRef, {
      inventorylog: arrayUnion(data),
      stock: stock,
      lastEdit: lastEdit,
      lastEditBy: lastEditBy,
    })
  }


  async updateArticleStock({articleId, inventorylog, note, stock, oldStockValue, lastEdit, lastEditBy}){
    
    const data = {
        // stock,
        // "inventorylog": inventorylog[0].inventorylog,
        "date": new Date().toISOString(),
        "stock": stock,
        "user": lastEditBy,
        "note": note,
        // "move": oldStockValue - stock,
        // "move": oldStockValue > stock ? (`-${oldStockValue - stock}`) : (`+${stock - oldStockValue}`)
        "move": stock > oldStockValue ? ( + (stock - oldStockValue)) : ( - (oldStockValue - stock))


    };
    
    let articleRef = doc(this.db, "articles", articleId)
    // articleRef.set(data, { merge: true });
    await updateDoc(articleRef, {
      inventorylog: arrayUnion(data),
      stock: stock,
      lastEdit: lastEdit,
      lastEditBy: lastEditBy,
    })
  }


  /*****************************
  ARTICLE END
  *****************************/

  /*****************************
  INVOICES START
  *****************************/
  // GET LATEST INVOICES WITH LIVE UPDATE
  getLatestOrganizationInvoices ({ organizationId, handler }) {
    onSnapshot(
      query(
        collection(this.db, "invoices"),
        where("organizationId", "==", organizationId),
        orderBy('dataCreated', 'desc'),
        limit(3)
      ),
      docs => handler(docs)
    )
  }

  getLatestInvoices ({ userId, handler }) {
    onSnapshot(
      query(
        collection(this.db, "invoices"),
        where("uid", "==", userId),
        orderBy('dataCreated', 'desc'),
        limit(3)
      ),
      docs => handler(docs)
    )
  }

  async getInvoices({ userId }) {
    const ref = query(collection(this.db, 'invoices'),
      // where('user', '==', user),
      where('uid', '==', userId),
      orderBy('dataCreated'),
      startAfter(this.latestDoc || 0),
      limit(2)
    )

      const data = await getDocs(ref)

      this.latestDoc = data.docs[data.docs.length - 1]

      return data
  }


  // GET FILTERED INVOICES WITH LIVE UPDATE
  getOrganizationInvoicesByDate({ organizationId, year, month, customer, teammember, handler }) {
    const queryConstraints = [
      where('organizationId', '==', organizationId),
      where('year', '==', year)
    ];
  
    if (month !== '-') {
      queryConstraints.push(where('month', '==', month));
    }
    if (customer !== '-') {
      queryConstraints.push(where('companyname', '==', customer));
    }
    if (teammember !== '-') {
      queryConstraints.push(where('uid', '==', teammember));
    }
  
    onSnapshot(
      query(
        collection(this.db, "invoices"),
        ...queryConstraints
      ),
      docs => handler(docs)
    );
  }
  

  getInvoicesByDate({ userId, year, month, customer, handler }) {
  const queryConstraints = [
    where('uid', '==', userId),
    where('year', '==', year)
  ];

  if (month !== '-') {
    queryConstraints.push(where('month', '==', month));
  }
  if (customer !== '-') {
    queryConstraints.push(where('companyname', '==', customer));
  }

  onSnapshot(
    query(
      collection(this.db, "invoices"),
      ...queryConstraints
    ),
    docs => handler(docs)
  );
}

  async getInvoiceDetails({ id, handler }) {
    onSnapshot(
      query(
        doc(this.db, 'invoices', id)
      ),
      docs => handler(docs)
    )

    // await this.db.collection('invoices')
    //   .doc(id)
    //   // .get()
    //   .onSnapshot(onSnapshot)
  }

  getLatestInvoiceNo ({ organizationId, handler }) {
    onSnapshot(
      query(
        collection(this.db, "invoices"),
        where('organizationId', '==', organizationId),
        orderBy('dataCreated', 'desc'),
        limit(3) // die letzten 3 weil wenn eine nicht vorhanden ist damit die lezte gültige genommen werden kann
      ),
      docs => handler(docs)
    )
  }

  // For Notification length
  async getOpenInvoicesByOrganization ({ organizationId, handler }) {
    const invoicesCol = collection(this.db, 'invoices')
    const invoicesQuery = query(
      invoicesCol,
        where('organizationId', '==', organizationId),
        where('payed', '==', false),
        where('cancelled', '==', false)
      )

      const snapshot = await getCountFromServer(invoicesQuery)

      return handler(snapshot.data().count)
  }

  async getOpenInvoicesByUser ({ userId, handler }) {
    const invoicesCol = collection(this.db, 'invoices')
    const invoicesQuery = query(
      invoicesCol,
        where('uid', '==', userId),
        where('payed', '==', false),
        where('cancelled', '==', false)
      )

      const snapshot = await getCountFromServer(invoicesQuery)

      return handler(snapshot.data().count)
  }


  async updateInvoiceField({ invoiceId, field, value, lastEdit, lastEditBy }) {
    if (!invoiceId || !field) {
      console.error("Invalid update request: Missing invoiceId or field.");
      return;
    }
  
    try {
      const invoiceRef = doc(this.db, "invoices", invoiceId);
  
        await updateDoc(invoiceRef, {
          [field]: value,
          lastEdit,
          lastEditBy,
        });
        console.log(`Updated ${field} for invoice ${invoiceId}`);
      
    } catch (error) {
      console.error("Update failed:", error);
    }
  }


  async updateInvoicePayableWithin({invoiceId, payableWithin, dueDate, lastEdit, lastEditBy}){
    const data = {
        payableWithin,
        dueDate,
        lastEdit,
        lastEditBy
    };
    const invoiceRef = doc(this.db, 'invoices', invoiceId)
    await setDoc(
      invoiceRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated invoice");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  async updateInvoiceDate({invoiceId, date, dueDate, year, month, lastEdit, lastEditBy }){
    const data = {
        date,
        dueDate,
        year,
        month,
        lastEdit,
        lastEditBy,

    };
    const invoiceRef = doc(this.db, 'invoices', invoiceId)
    await setDoc(
      invoiceRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated invoice");
    })
    .catch((error) => {
      console.error(error);
    });
  }


  async updateRecurringInvoiceMode({ invoiceId, recurringInvoice, remainingOccurrences, nextRecurringDate, lastEdit, lastEditBy }) {
    console.log('Next Recurring Date: ' + nextRecurringDate)
    // Normalisiere `remainingOccurrences`
    const normalizedRemainingOccurrences = typeof remainingOccurrences === 'number'
        ? remainingOccurrences
        : parseFloat(remainingOccurrences) || -1;

    const data = {
        recurringInvoice,
        remainingOccurrences: normalizedRemainingOccurrences,
        lastEdit,
        lastEditBy,
    };

    // Berechnung von `nextRecurringDate`, falls es nicht übergeben wurde
    if (recurringInvoice) {
        // Wenn `nextRecurringDate` übergeben wird, setze es
        if (nextRecurringDate) {
            data.nextRecurringDate = nextRecurringDate;
        }
        // Standardwert für `recurringInterval` setzen, falls es nicht gesetzt wurde
        if (!data.recurringInterval) {
          data.recurringInterval = 'yearly'; // Standardwert für Intervall setzen
        }
    } else {
        // Setze Felder zurück, wenn wiederkehrend deaktiviert wird
        data.remainingOccurrences = deleteField();
        data.nextRecurringDate = deleteField();
        data.recurringInterval = deleteField();
    }

    const invoiceRef = doc(this.db, 'invoices', invoiceId);

    try {
        // Speichern der Daten in der Datenbank
        await setDoc(invoiceRef, data, { merge: true });
        console.log('Updated invoice in database:', data);
    } catch (error) {
        console.error('Error updating invoice:', error);
    }
}

  async updateRemainingInvoiceOccurrences({invoiceId, remainingOccurrences, lastEdit, lastEditBy}){
    const data = {
        // remainingOccurrences,
        // remainingOccurrences: typeof remainingOccurrences === 'number' ? remainingOccurrences : parseFloat(remainingOccurrences), // Ensure number type
        remainingOccurrences: typeof remainingOccurrences === 'number'
          ? remainingOccurrences
          : parseFloat(remainingOccurrences) || -1,
        lastEdit,
        lastEditBy
    };
    const invoiceRef = doc(this.db, 'invoices', invoiceId)
    await setDoc(
      invoiceRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated invoice");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  async updateRecurringInvoiceInterval({invoiceId, recurringInterval, nextRecurringDate, lastEdit, lastEditBy}){
    const data = {
        recurringInterval,
        nextRecurringDate,
        lastEdit,
        lastEditBy
    };
    const invoiceRef = doc(this.db, 'invoices', invoiceId)
    await setDoc(
      invoiceRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated invoice");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  async updateInvoiceCancellation({invoiceId, cancelled, lastEdit, lastEditBy}){
    const data = {
        cancelled,
        lastEdit,
        lastEditBy
    };
    const invoiceRef = doc(this.db, 'invoices', invoiceId)
    await setDoc(
      invoiceRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated invoice");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  async updateInvoicePayed({invoiceId, payed, payedWithCashDiscount, paymentDate, note, lastEdit, lastEditBy}){
    const data = {
        payed,
        payedWithCashDiscount,
        paymentDate,
        note,
        lastEdit,
        lastEditBy
    };
    const invoiceRef = doc(this.db, 'invoices', invoiceId)
    // let invoiceRef = this.db.collection('invoices')
    // .doc(invoiceId)
    await setDoc(
      invoiceRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated invoice");
    })
    .catch((error) => {
      console.error(error);
    });
  }


  async appendInvoicePositions({invoiceId, items, lastEdit, lastEditBy}){
    // console.log(items)
    const data = {
        "amount": items[0].amount,
        "articlenr": items[0].articlenr,
        "description": items[0].description,
        "itemtitle": items[0].itemtitle,
        "price": items[0].price,
        "taxpercentage": items[0].taxpercentage,
        // "total": items[0].total,
        "unit": items[0].unit,
        "stockmanagement": items[0].stockmanagement,
        "stock": items[0].stock,
        "id": items[0].id
    };

    let invoiceRef = doc(this.db, "invoices", invoiceId)

    await updateDoc(invoiceRef, {
      items: arrayUnion(data),
      lastEdit: lastEdit,
      lastEditBy: lastEditBy,
    })
  }

  // CLEAN VERSION
  async updateInvoicePosition({invoiceId, invoiceItems, lastEdit, lastEditBy}){
    // console.log(invoiceItems)
    // console.log(idx)

    //Grab through reference all comments Array in firestore
    let actualPosition = invoiceItems
    // console.log(invoiceId)

    let invoiceRef = doc(this.db, "invoices", invoiceId)

    await updateDoc(invoiceRef, {
      items: actualPosition,
      lastEdit: lastEdit,
      lastEditBy: lastEditBy,
    })
  }

  async updateInvoiceSendt({invoiceId, invoiceSendt, invoiceSendtDate, reminderLevel, reminderLastSendtDate, lastEdit, lastEditBy}){
    const data = {
        invoiceSendt,
        invoiceSendtDate,
        lastEdit,
        lastEditBy
    };
    if (reminderLevel !== undefined) {
      data.reminderLevel = reminderLevel
    }
    if (reminderLastSendtDate !== undefined) {
      data.reminderLastSendtDate = reminderLastSendtDate
    }
    const invoiceRef = doc(this.db, 'invoices', invoiceId)
    await setDoc(
      invoiceRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated invoice");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  /*****************************
  INVOICES END
  *****************************/

  /*************************************
  OFFERS START
  *************************************/
  // GET LATEST OFFERS WITH LIVE UPDATE FOR INITIAL FETCH
  getLatestOrganizationOffers ({ organizationId, handler }) {
    onSnapshot(
      query(
        collection(this.db, "offers"),
        where('organizationId', '==', organizationId),
        orderBy('dataCreated', 'desc'),
        limit(3)
      ),
      docs => handler(docs)
    )
  }
  
  getLatestOffers ({ userId, handler }) {
    onSnapshot(
      query(
        collection(this.db, "offers"),
        where('uid', '==', userId),
        orderBy('dataCreated', 'desc'),
        limit(3)
      ),
      docs => handler(docs)
    )
  }

  // getOffer({user, id, onSnapshot}) {
  //   const offerRef = this.db.collection('offers').doc('2qhBT24kVJ7idRb19xOE')
  //   // const usersRef = this.db.collection('users').where('username', '==', username)
  //
  //   offerRef
  //     .onSnapshot(onSnapshot)
  //   }


  async getOffers({ userId }) {
    // var lastItem = null
    const ref = query(collection(this.db, 'offers'),
      // where('user', '==', user),
      where('uid', '==', userId),
      orderBy('dataCreated'),
      startAfter(this.latestDoc || 0),
      limit(2)
    )

      const data = await getDocs(ref)

      this.latestDoc = data.docs[data.docs.length - 1]

      return data
  }

  getOfferSearchItems({ objectID, onSnapshot }) {
    return this.db.collection('offers')
      .doc(objectID)
      // .get()
      .onSnapshot(onSnapshot)
  }

  // GET FILTERED OFFERS WITH LIVE UPDATE
getOrganizationOffersByDate({ organizationId, year, month, customer, teammember, handler }) {
  const queryConstraints = [
    where('organizationId', '==', organizationId),
    where('year', '==', year)
  ];

  if (month !== '-') {
    queryConstraints.push(where('month', '==', month));
  }
  if (customer !== '-') {
    queryConstraints.push(where('companyname', '==', customer));
  }
  if (teammember !== '-') {
    queryConstraints.push(where('uid', '==', teammember));
  }

  onSnapshot(
    query(
      collection(this.db, "offers"),
      ...queryConstraints
    ),
    docs => handler(docs)
  );
}


getOffersByDate({ userId, year, month, customer, handler }) {
  const queryConstraints = [
    where('uid', '==', userId),
    where('year', '==', year)
  ];

  if (month !== '-') {
    queryConstraints.push(where('month', '==', month));
  }
  if (customer !== '-') {
    queryConstraints.push(where('companyname', '==', customer));
  }

  onSnapshot(
    query(
      collection(this.db, "offers"),
      ...queryConstraints
    ),
    docs => handler(docs)
  );
}



  async getOfferDetails({ id, handler }) {
    onSnapshot(
      query(
        doc(this.db, 'offers', id)
      ),
      docs => handler(docs)
    )
  }

  // INFINITE LOAD OF OFFERS
  // async getOffers({ user, onSnapshot }) {
  //     // var lastItem = null
  //     const ref = this.db.collection('offers')
  //       .where('user', '==', user)
  //       .orderBy('dataCreated')
  //       .startAfter(this.latestDoc || 0)
  //       .limit(2)
  //       .onSnapshot(onSnapshot)
  //       // .onSnapshot(onSnapshot)
  //
  //       // const data = await ref.get()
  //       const data = await ref
  //
  //       this.latestDoc = data.docs[data.docs.length - 1]
  //
  //       return data
  // }

  // getStatisticOffers ({ user, onSnapshot }) {
  //   return this.db.collection('offers')
  //     .where('user', '==', user)
  //     // .where('year', '==', year)
  //     // .orderBy('dataCreated', 'desc')
  //     .onSnapshot(onSnapshot)
  // }

  // For Notification length
  async getOpenOffersByOrganization ({ organizationId, handler }) {
    const offersCol = collection(this.db, 'offers')
    const offersQuery = query(
      offersCol,
        where('organizationId', '==', organizationId),
        where('adopted', '==', false),
        where('rejected', '==', false)
      )

      const snapshot = await getCountFromServer(offersQuery)
      
      return handler(snapshot.data().count)
  }

  async getOpenOffersByUser ({ userId, handler }) {
    const offersCol = collection(this.db, 'offers')
    const offersQuery = query(
      offersCol,
        where('uid', '==', userId),
        where('adopted', '==', false),
        where('rejected', '==', false)
      )

      const snapshot = await getCountFromServer(offersQuery)
      
      return handler(snapshot.data().count)
    
  }

  // getOpenOffers ({ userId, handler }) {
  //   onSnapshot(
  //     query(
  //       collection(this.db, "offers"),
  //       // where("user", "==", user),
  //       where('uid', '==', userId),
  //       where('adopted', '==', false)
  //     ),
  //     docs => handler(docs)
  //   )
  // }

  getLatestOfferNo ({ organizationId, handler }) {
    onSnapshot(
      query(
        collection(this.db, "offers"),
        where('organizationId', '==', organizationId),
        orderBy('dataCreated', 'desc'),
        limit(1)
      ),
      docs => handler(docs)
    )
  }


  async updateOfferField({ offerId, field, value, lastEdit, lastEditBy }) {
    if (!offerId || !field) {
      console.error("Invalid update request: Missing offerId or field.");
      return;
    }
  
    try {
      const offerRef = doc(this.db, "offers", offerId);
  
        await updateDoc(offerRef, {
          [field]: value,
          lastEdit,
          lastEditBy,
        });
        console.log(`Updated ${field} for offer ${offerId}`);
      
    } catch (error) {
      console.error("Update failed:", error);
    }
  }

  async updateOfferDate({offerId, date, year, month, lastEdit, lastEditBy }){
    const data = {
        date,
        year,
        month,
        lastEdit,
        lastEditBy
    };
    const offerRef = doc(this.db, 'offers', offerId)
    await setDoc(
      offerRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated offer");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  async updateOfferExpiryDate({offerId, expiryDate, lastEdit, lastEditBy }){
    const data = {
        expiryDate,
        lastEdit,
        lastEditBy,
    };
    const offerRef = doc(this.db, 'offers', offerId)
    await setDoc(
      offerRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated offer");
    })
    .catch((error) => {
      console.error(error);
    });
  }


  async updateOfferPrice({offerId, price, lastEdit, lastEditBy}){
    const data = {
        price,
        lastEdit,
        lastEditBy
    };
    const offerRef = doc(this.db, 'offers', offerId)
    await setDoc(
      offerRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated offer");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  async updateOfferDiscount({offerId, discount, lastEdit, lastEditBy}){
    const data = {
        discount,
        lastEdit,
        lastEditBy
    };
    const offerRef = doc(this.db, 'offers', offerId)
    await setDoc(
      offerRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated offer");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  async updateOfferRejection({offerId, rejected, rejectedDate, lastEdit, lastEditBy}){
    const data = {
        rejected,
        rejectedDate,
        lastEdit,
        lastEditBy
    };
    const offerRef = doc(this.db, 'offers', offerId)
    await setDoc(
      offerRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated offer");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  async updateOfferAdopted({offerId, adopted, adoptedDate, lastEdit, lastEditBy}){
    const data = {
        adopted,
        adoptedDate,
        lastEdit,
        lastEditBy
    };
    const offerRef = doc(this.db, 'offers', offerId)
    await setDoc(
      offerRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated offer");
    })
    .catch((error) => {
      console.error(error);
    });
  }

  // async updateOfferPosition({idx, offerId, offerItems, lastEdit, lastEditBy}){
  async updateOfferPosition({offerId, offerItems, lastEdit, lastEditBy}){
    // console.log(offerItems)
    // console.log(offerItems[0].description)
    // console.log(idx)

    //Grab through reference offers Array in firestore
    let actualPosition = offerItems
    // console.log(actualPosition)

    let offerRef = doc(this.db, 'offers', offerId)

    await updateDoc(offerRef, {
      items: actualPosition,
      lastEdit: lastEdit,
      lastEditBy: lastEditBy,
    })
  }


  async appendOfferPositions({offerId, items, lastEdit, lastEditBy}){
    // console.log(items)
    const data = {
        "amount": items[0].amount,
        "articlenr": items[0].articlenr,
        "description": items[0].description,
        "itemtitle": items[0].itemtitle,
        "price": items[0].price,
        "taxpercentage": items[0].taxpercentage,
        // "total": items[0].total,
        "unit": items[0].unit,
        "stockmanagement": items[0].stockmanagement,
        "stock": items[0].stock,
        "id": items[0].id
    };

    let offerRef = doc(this.db, "offers", offerId)

    await updateDoc(offerRef, {
      items: arrayUnion(data),
      lastEdit: lastEdit,
      lastEditBy: lastEditBy,
    })
  }

  async updateOfferSendt({offerId, offerSendt, offerSendtDate, lastEdit, lastEditBy }){
    const data = {
        offerSendt,
        offerSendtDate,
        lastEdit,
        lastEditBy
    };
    const offerRef = doc(this.db, 'offers', offerId)
    await setDoc(
      offerRef, data,
      { merge: true }
    ).then(() => {
      console.log("Updated offer");
    })
    .catch((error) => {
      console.error(error);
    });
  }
  /*************************************
  OFFER END
  *************************************/


  // body: JSON.stringify(data),

  // async createAuthor({authorName}){
  //   const createAuthorCallable = this.functions.httpsCallable('createAuthor');
  //   return createAuthorCallable({
  //     authorName
  //   });
  // }



  // async getSettings ({ user, onSnapshot }) {
  //   return this.db.collection('settings').where('user', '==', user).get()
  // }

  // GET SETTINGS WITH LIVE UPDATE
  getSettings ({ userId, handler }) {
    onSnapshot(
      query(
        collection(this.db, "settings"),
        // where('user', '==', user)
        where('uid', '==', userId),
      ),
      docs => handler(docs)
    )
  }

  
  getOrganizationSettings({ organizationId, handler }) {
    onSnapshot(
      query(
        collection(this.db, "settings"),
        where('organizationId', '==', organizationId)
      ),
      docs => handler(docs)
    )
  }


  // registerMFA() {
  //   const user = this.auth.currentUser;
    
  //   // const recaptchaVerifier = new RecaptchaVerifier('recaptcha-container-id', undefined, this.auth);

  //   const recaptchaVerifier = new RecaptchaVerifier("sign-in-button", {
  //     "size": "invisible",
  //     "callback": function(response) {
  //         // reCAPTCHA solved, you can proceed with
  //         // phoneAuthProvider.verifyPhoneNumber(...).
  //         // onSolvedRecaptcha();
  //     }
  // }, this.auth);


  //     multiFactor(user).getSession()
  //       .then(function (multiFactorSession) {
  //           // Specify the phone number and pass the MFA session.
  //           const phoneInfoOptions = {
  //             // phoneNumber: phoneNumber,
  //             phoneNumber: '+436763547783',
  //             session: multiFactorSession
  //           };

  //           const phoneAuthProvider = new PhoneAuthProvider(this.auth);
  //           console.log('drinnen')
  //           // Send SMS verification code.
  //           return phoneAuthProvider.verifyPhoneNumber(phoneInfoOptions, recaptchaVerifier);
  //       }).then(function (verificationId) {
  //           // Ask user for the verification code. Then:
  //           // const cred = PhoneAuthProvider.credential(verificationId, verificationCode);
  //           const cred = PhoneAuthProvider.credential(verificationId, 123456);
  //           const multiFactorAssertion = PhoneMultiFactorGenerator.assertion(cred);
  //           console.log('weiter')
  //           const mfaDisplayName = 'Mario'
  //           // Complete enrollment.
  //           // return multiFactor(user).enroll(multiFactorAssertion, mfaDisplayName);
  //           return multiFactor(user).enroll(multiFactorAssertion, mfaDisplayName);
  //       });
  // }


//   async register(email, password) {
//     try {
//         await createUserWithEmailAndPassword(this.auth, email, password)


//         const user = this.auth.currentUser;

//         const actionCodeSettings = {
//           // url: `https://www.verwaldo-app-shirley-74d233.netlify.app/login/?email=${email}`,
//           // url: `http://localhost:8000/app/profile`
//           url: `http://localhost:8000/app/menu`
//         };
        
//           sendEmailVerification(user, actionCodeSettings);

//         return user; // Return the user object on success


//     } catch (error) {
//         return error.message; // Return the error message on failure
//     }
// }

// async register({ email, password }) {
//   try {
//       const userCredential = await createUserWithEmailAndPassword(this.auth, email, password);
//       console.log(userCredential);

//       const user = this.auth.currentUser;

//       const actionCodeSettings = {
//           url: `http://localhost:8000/app/menu`
//       };

//       await sendEmailVerification(user, actionCodeSettings);

//       return user; // Return the user object on success
//   } catch (error) {
//       console.log(error.message);
//       throw new Error(error.message); // Throw the error to be caught by the caller
//   }
// }
  
  // async register({email, password}) {
  //   await createUserWithEmailAndPassword(this.auth, email, password)
  //   .then((res) => {
  //     console.log(res)
      
  //     const user = this.auth.currentUser;

  //     const actionCodeSettings = {
  //       // url: `https://www.verwaldo-app-shirley-74d233.netlify.app/login/?email=${email}`,
  //       // url: `http://localhost:8000/app/profile`
  //       url: `http://localhost:8000/app/menu`
  //     };

  //     sendEmailVerification(user, actionCodeSettings);

  

  //   })
  //   .catch((error) => {
  //     console.log(error.message)
  //     return error.message
      
  //     // catch any errors, set a data property called error
  //     this.error = error.message;

  //   });

  //   // const createUserCallable = this.functions.httpsCallable('createUser');
  //   // return createUserCallable({
  //   //   username
  //   // })
  // }

  async setUserRole(uid, event) {
    const addMessage = httpsCallable(
      this.functions,
      "setUserRole")

    var data = { uid: uid.user, role: { [uid.role]: true }, username: uid.username };

     addMessage(data)
         .then(function(result) {
             console.log(result);
         })
         .catch(function(error) {
             console.log(error)
         });
  }


  createUser({user, username, email, category, organization, organizationId, teamMembers}) {
    // var user = this.auth.currentUser;

    const createUserCallable = httpsCallable(this.functions, 'createUser')
    return new Promise((resolve) => {
      resolve(createUserCallable({
        username,
        email,
        category,
        organization,
        organizationId,
        teamMembers
      }))
    })
  }

  // async removeMfa({userId}) {
  //   const updateUserCallable = httpsCallable(this.functions, 'removeMfa')
    
  //   updateUserCallable(userId)
      
  //        .then(function(result) {
  //            console.log(result);
  //        })
  //        .catch(function(error) {
  //            console.log(error)
  //        });
  // }

  async updateUserClaims({ uid, organizationId }) {
    const updateUserClaimsCallable = httpsCallable(this.functions, 'updateUserClaims');
  
    try {
      // Call the function and pass data as an object
      const result = await updateUserClaimsCallable({ uid, organizationId });
      console.log('User claims updated:', result.data);
      return result.data;
    } catch (error) {
      console.error('Error updating user claims:', error);
      throw error; // Fehler weiterwerfen, damit der Aufrufer sie behandeln kann
    }
  }

  async updateRole (userId, newRole, organizationId) {
    try {
      const updateCustomClaims = httpsCallable(this.functions, 'updateUserRole');
      const response = await updateCustomClaims({
        uid: userId,
        newRole,
        organizationId,
      });
  
      console.log(response.data.message);
    } catch (error) {
      console.error('Error updating role:', error);
      throw error;
    }
  };


  async removeMfa({ userId }) {
    const updateUserCallable = httpsCallable(this.functions, 'removeMfa');
    
    try {
      const result = await updateUserCallable(userId);
      console.log(result);
      return result;
    } catch (error) {
      console.error(error);
      throw error; // Wichtige Fehler weiterwerfen, um sie in der aufrufenden Funktion zu behandeln
    }
  }

  // async removeMfa({ userId }) {
  //   const updateUserCallable = httpsCallable(this.functions, 'removeMfa');
    
  //   try {
  //     const result = await updateUserCallable({ userId });
  //     console.log(result);
  
  //     // Token des Benutzers nach Entfernen von MFA erneuern
  //     await this.auth.currentUser.getIdToken(true);
      
  //     return result;
  //   } catch (error) {
  //     console.error(error);
  //     throw error;
  //   }
  // }

  

  async updateUserMFA({userId, telephone, displayName}) {
    // var user = this.auth.currentUser;
    const factorId = 'phone'
    // console.log(userId)
    const updateUserCallable = httpsCallable(this.functions, 'updateUserMfa')
    return new Promise((resolve) => {
      resolve(updateUserCallable({
        userId,
        telephone,
        displayName,
        factorId
      }))
    })
  }


  async createMember({user, username, email, organizationId, organization, password, role}) {
    let member

    await createUserWithEmailAndPassword(this.auth, email, password)
    .then(() => {
      // const user = this.auth.currentUser;
      member = this.auth.currentUser

      const actionCodeSettings = {
        // url: `https://www.verwaldo-app-shirley-74d233.netlify.app/login/?email=${email}`,
        // url: `http://localhost:8000/app/menu`
        url: `https://www.app.verwaldo.com/app/menu/`
      };

      sendEmailVerification(member, actionCodeSettings)
    })
    
      .then(() => {  
        
        // console.log(response.data.uid)
        const uid = member.uid
        // const userData = user.data
        const createMemberCallable = httpsCallable(this.functions, 'createMember');
        return new Promise((resolve) => {
          resolve(createMemberCallable({
            username,
            email,
            organization,
            organizationId,
            uid,
            role
          }))
        })

        .catch(error => {
          this.error = error.message;
        });
      })
    }


  // async checkExistingUser({username, onSnapshot }) {
  //   var docRef = this.db.collection("users").doc(username);
  //
  //   await docRef.get().then((doc) => {
  //   if (doc.exists) {
  //       // console.log("Document data:", doc.data());
  //       console.log(true)
  //       // doc.data()
  //   // } else {
  //   //     // doc.data() will be undefined in this case
  //   //     // console.log("No such document!");
  //   //     console.log(false)
  //   // }
  //   }
  //   }).catch((error) => {
  //       console.log("Error searching existing users:", error);
  //   }).onSnapshot(onSnapshot)
  // }

  getUserData({username, handler}) {
    onSnapshot(
      query(
        doc(this.db, "users", username)
      ),
      docs => handler(docs)
    )
  }

  // checkExistingUser({username, handler}) {
  //   onSnapshot(
  //     query(
  //       doc(this.db, "users", username),
  //     ),
  //     docs => handler(docs)
  //   )
  // }

  // checkExistingUser({username, handler}) {
  //   onSnapshot(
  //     query(
  //       collection(this.db, "users"),
  //       where('username', '==', username)
  //     ),
  //     docs => handler(docs)
  //   )
  // }

  /************
   *  COUNT
   * FEATURE
   ***********/
  // async checkExistingUser({username, handler}) {
  //   const usersCol = collection(this.db, 'users')
  //   const usersQuery = query(
  //     usersCol,
  //     where('username', '==', username)
  //   )

  //   const snapshot = await getCountFromServer(usersQuery)
    
  //   return handler(snapshot.data().count)
  // }

  // async checkExistingUser({ username, organizationId, handler }) {
  //   try {
  //     const usersCol = collection(this.db, 'users');
      
  //     // Abfrage innerhalb der Organisation
  //     const usersQuery = query(
  //       usersCol,
  //       where('username', '==', username),
  //       where('organizationId', '==', organizationId) // Nur Benutzer in derselben Organisation
  //     );
  
  //     const snapshot = await getCountFromServer(usersQuery);
      
  //     return handler(snapshot.data().count);
      
  //   } catch (error) {
  //     console.error('Fehler beim Überprüfen des Benutzers:', error);
  //     handler(0)
  //   }
  // }

  async checkExistingUser({ username, organizationId }) {
    const usersCol = collection(this.db, 'users');
    const usersQuery = query(
        usersCol,
        where('username', '==', username),
        where('organizationId', '==', organizationId)
    );

    const snapshot = await getCountFromServer(usersQuery);
    
    // Rückgabewert der Abfrage (entweder 0 oder 1)
    return snapshot.data().count;
}

listAllMembers({ organizationId, handler }) {
  try {
    const q = query(
      collection(this.db, "users"),
      where('organizationId', '==', organizationId)
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        if (snapshot.empty) {
          console.warn('No documents found.');
        } else {
          handler(snapshot); // Aufruf des Handlers mit dem Snapshot
        }
      },
      (error) => {
        console.error('Error fetching members:', error);
      }
    );

    // Unsubscribe-Handler zurückgeben
    return unsubscribe;
  } catch (error) {
    console.error('Unexpected error:', error);
    throw error; // Weitergabe des unerwarteten Fehlers
  }
}

  

  async updateProfileEmail({ email, organizationId }) {
    const auth = getAuth();
    // const db = getFirestore();
    const user = auth.currentUser;
  
    if (!user) {
      console.error('No authenticated user found.');
      return;
    }
  
    try {
      // 1. E-Mail des Benutzers in Firebase Auth aktualisieren
      await updateEmail(user, email);
      console.log('Email updated successfully in Auth');
  
      // 2. Überprüfe, ob der Benutzer eine E-Mail-Adresse hat
      if (user.email) {
        // Sende eine Verifizierungs-E-Mail an die neue Adresse
        await sendEmailVerification(user);
        console.log('Verification email sent successfully');
      } else {
        console.log('User does not have an email address to verify');
      }
      
      // 3. Aktualisiere die E-Mail-Adresse in Firestore (teamMembers)
      // const userDocRef = doc(db, 'users', organizationId);  // Zugriff auf das Benutzer-Dokument
      
      // // Hole das aktuelle Dokument
      // const docSnap = await getDoc(userDocRef);
      // if (!docSnap.exists()) {
      //   throw new Error('User document does not exist');
      // }
  
      // const userData = docSnap.data();
      // const teamMembers = userData.teamMembers || [];
      
      // E-Mail im teamMembers-Array nur für das richtige Mitglied aktualisieren
      // const updatedTeamMembers = teamMembers.map(member => {
      //   if (member.id === user.uid) {  // Prüfe, ob es das richtige Mitglied ist
      //     return {
      //       ...member,
      //       email: email // E-Mail nur für dieses Mitglied aktualisieren
      //     };
      //   }
      //   return member; // Andere Mitglieder unverändert zurückgeben
      // });
  
      // Speichere die aktualisierten teamMembers zurück in die Datenbank
      // await updateDoc(userDocRef, {
      //   teamMembers: updatedTeamMembers
      // });
      // console.log('Team Members updated');
      
    } catch (error) {
      console.error('Error during email update or verification:', error);
      throw error;
    }
  }
  


  sendCustomPasswordResetEmail({ email, lang }) {
    const callable = httpsCallable(this.functions, 'sendPasswordResetEmail');
    return callable({ email, lang });
  }
  
  async resetPassword(email) {
    try {
        await sendPasswordResetEmail(this.auth, email);
        console.log("Successfully sendt reset password confirmation");
        return { success: true, message: "Successfully sendt reset password confirmation", code: "send-reset-pass-confirm" };
    } catch (error) {
        console.error("Error sending resetting password:", error);
        return { success: false, error: error };
    }
}



  // async deleteUser({user, email, password}) {
  //   var user = this.auth.currentUser;
  //   // console.log(user)
  //   return new Promise( (resolve, reject) => {
  //     const reset = resolve(user.delete())
  //       // promise is RESOLVED , when execution reaches this line of code
  //        reset.then((response) => console.log(response))// After 1 second, RESOLVE the promise with value 'wohoo'
  //     })
  // }


  async deleteUser({ user }) {
    try {
      const currentUser = this.auth.currentUser;
      if (currentUser) {
        await currentUser.delete();
        console.log('Benutzer erfolgreich gelöscht');
      }
    } catch (error) {
      console.error('Fehler beim Löschen des Benutzers:', error);
      throw error;
    }
  }


  // async deleteUser({ user }) {
  //   try {
  //     const currentUser = this.auth.currentUser;
  
  //     if (currentUser) {
  //       // Benutzeranmeldedaten prüfen
  //       if (!user.email || !user.password) {
  //         throw new Error("Missing email or password for reauthentication");
  //       }
  
  //       // Anmeldedaten erstellen
  //       const credential = EmailAuthProvider.credential(user.email, user.password);
  
  //       // Reauthentifizierung durchführen
  //       await reauthenticateWithCredential(currentUser, credential);
  //       console.log("Reauthentication successful");
  
  //       // Benutzer löschen
  //       await currentUser.delete();
  //       console.log("Benutzer erfolgreich gelöscht");
  //     }
  //   } catch (error) {
  //     if (error.code === "auth/requires-recent-login") {
  //       console.error("Reauthentication required before deletion:", error);
  //       throw new Error("Please log in again to confirm deletion.");
  //     } else {
  //       console.error("Fehler beim Löschen des Benutzers:", error);
  //       throw error;
  //     }
  //   }
  // }



  googleSignIn = async () => {
    // await signInWithRedirect(this.auth, googleProvider)
    await signInWithPopup(this.auth, googleProvider)
      .then((user) => {
        console.log(user);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  async newUser(authResult) {
    const userInfo = authResult ? getAdditionalUserInfo(authResult) : null
    const isNewUser = userInfo?.isNewUser || false
    if (isNewUser){
      console.log(isNewUser)
    }
    return isNewUser
  }


  // var uiConfig = {
  //       callbacks: {
  //         signInSuccessWithAuthResult: function(authResult, redirectUrl) {
  //           var user = authResult.user;
  //           var credential = authResult.credential;
  //           var operationType = authResult.operationType;
  //           // Do something with the returned AuthResult.
  //           // Return type determines whether we continue the redirect automatically
  //           // or whether we leave that to developer to handle.
  //           return true;
  //         },
  //       }
  // }


  // async logout() {
  //   await signOut(this.auth);
  // }

  async logout() {
    try {
        await signOut(this.auth);
        console.log("Successfully signed out");
        navigate('/app/login');
        return "Successfully signed out"
    } catch (error) {
        console.error("Error signing out:", error);
        return error
    }
  }
  
}


let firebaseInstance;

function getFirebaseInstance() {
  if(!firebaseInstance){
    firebaseInstance = new Firebase();
    return firebaseInstance;
  }else if(firebaseInstance){
    return firebaseInstance
  }else{
    return null;
  }
}



export default getFirebaseInstance;
